import * as React3 from 'react';
import React3__default, { createContext, useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { Input, Typography, Alert, Space, Button, Spin, Splitter, Collapse, Divider, Card, Row, Col, Tooltip, Tag, AutoComplete } from 'antd';
import { parse, isValid, format, parseISO } from 'date-fns';
import { Document, Page } from 'react-pdf';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var IconContext = /* @__PURE__ */ createContext({});
var Context_default = IconContext;

// ../../node_modules/clsx/dist/clsx.mjs
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

// ../../node_modules/@ant-design/fast-color/es/presetColors.js
var presetColors_default = {
  aliceblue: "9ehhb",
  antiquewhite: "9sgk7",
  aqua: "1ekf",
  aquamarine: "4zsno",
  azure: "9eiv3",
  beige: "9lhp8",
  bisque: "9zg04",
  black: "0",
  blanchedalmond: "9zhe5",
  blue: "73",
  blueviolet: "5e31e",
  brown: "6g016",
  burlywood: "8ouiv",
  cadetblue: "3qba8",
  chartreuse: "4zshs",
  chocolate: "87k0u",
  coral: "9yvyo",
  cornflowerblue: "3xael",
  cornsilk: "9zjz0",
  crimson: "8l4xo",
  cyan: "1ekf",
  darkblue: "3v",
  darkcyan: "rkb",
  darkgoldenrod: "776yz",
  darkgray: "6mbhl",
  darkgreen: "jr4",
  darkgrey: "6mbhl",
  darkkhaki: "7ehkb",
  darkmagenta: "5f91n",
  darkolivegreen: "3bzfz",
  darkorange: "9yygw",
  darkorchid: "5z6x8",
  darkred: "5f8xs",
  darksalmon: "9441m",
  darkseagreen: "5lwgf",
  darkslateblue: "2th1n",
  darkslategray: "1ugcv",
  darkslategrey: "1ugcv",
  darkturquoise: "14up",
  darkviolet: "5rw7n",
  deeppink: "9yavn",
  deepskyblue: "11xb",
  dimgray: "442g9",
  dimgrey: "442g9",
  dodgerblue: "16xof",
  firebrick: "6y7tu",
  floralwhite: "9zkds",
  forestgreen: "1cisi",
  fuchsia: "9y70f",
  gainsboro: "8m8kc",
  ghostwhite: "9pq0v",
  goldenrod: "8j4f4",
  gold: "9zda8",
  gray: "50i2o",
  green: "pa8",
  greenyellow: "6senj",
  grey: "50i2o",
  honeydew: "9eiuo",
  hotpink: "9yrp0",
  indianred: "80gnw",
  indigo: "2xcoy",
  ivory: "9zldc",
  khaki: "9edu4",
  lavenderblush: "9ziet",
  lavender: "90c8q",
  lawngreen: "4vk74",
  lemonchiffon: "9zkct",
  lightblue: "6s73a",
  lightcoral: "9dtog",
  lightcyan: "8s1rz",
  lightgoldenrodyellow: "9sjiq",
  lightgray: "89jo3",
  lightgreen: "5nkwg",
  lightgrey: "89jo3",
  lightpink: "9z6wx",
  lightsalmon: "9z2ii",
  lightseagreen: "19xgq",
  lightskyblue: "5arju",
  lightslategray: "4nwk9",
  lightslategrey: "4nwk9",
  lightsteelblue: "6wau6",
  lightyellow: "9zlcw",
  lime: "1edc",
  limegreen: "1zcxe",
  linen: "9shk6",
  magenta: "9y70f",
  maroon: "4zsow",
  mediumaquamarine: "40eju",
  mediumblue: "5p",
  mediumorchid: "79qkz",
  mediumpurple: "5r3rv",
  mediumseagreen: "2d9ip",
  mediumslateblue: "4tcku",
  mediumspringgreen: "1di2",
  mediumturquoise: "2uabw",
  mediumvioletred: "7rn9h",
  midnightblue: "z980",
  mintcream: "9ljp6",
  mistyrose: "9zg0x",
  moccasin: "9zfzp",
  navajowhite: "9zest",
  navy: "3k",
  oldlace: "9wq92",
  olive: "50hz4",
  olivedrab: "472ub",
  orange: "9z3eo",
  orangered: "9ykg0",
  orchid: "8iu3a",
  palegoldenrod: "9bl4a",
  palegreen: "5yw0o",
  paleturquoise: "6v4ku",
  palevioletred: "8k8lv",
  papayawhip: "9zi6t",
  peachpuff: "9ze0p",
  peru: "80oqn",
  pink: "9z8wb",
  plum: "8nba5",
  powderblue: "6wgdi",
  purple: "4zssg",
  rebeccapurple: "3zk49",
  red: "9y6tc",
  rosybrown: "7cv4f",
  royalblue: "2jvtt",
  saddlebrown: "5fmkz",
  salmon: "9rvci",
  sandybrown: "9jn1c",
  seagreen: "1tdnb",
  seashell: "9zje6",
  sienna: "6973h",
  silver: "7ir40",
  skyblue: "5arjf",
  slateblue: "45e4t",
  slategray: "4e100",
  slategrey: "4e100",
  snow: "9zke2",
  springgreen: "1egv",
  steelblue: "2r1kk",
  tan: "87yx8",
  teal: "pds",
  thistle: "8ggk8",
  tomato: "9yqfb",
  turquoise: "2j4r4",
  violet: "9b10u",
  wheat: "9ld4j",
  white: "9zldr",
  whitesmoke: "9lhpx",
  yellow: "9zl6o",
  yellowgreen: "61fzm"
};

// ../../node_modules/@ant-design/fast-color/es/FastColor.js
var round = Math.round;
function splitColorStr(str, parseNum) {
  const match = str.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [];
  const numList = match.map((item) => parseFloat(item));
  for (let i = 0; i < 3; i += 1) {
    numList[i] = parseNum(numList[i] || 0, match[i] || "", i);
  }
  if (match[3]) {
    numList[3] = match[3].includes("%") ? numList[3] / 100 : numList[3];
  } else {
    numList[3] = 1;
  }
  return numList;
}
var parseHSVorHSL = (num, _, index) => index === 0 ? num : num / 100;
function limitRange(value, max) {
  const mergedMax = max || 255;
  if (value > mergedMax) {
    return mergedMax;
  }
  if (value < 0) {
    return 0;
  }
  return value;
}
var FastColor = class _FastColor {
  constructor(input) {
    /**
     * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
     */
    __publicField(this, "isValid", true);
    /**
     * Red, R in RGB
     */
    __publicField(this, "r", 0);
    /**
     * Green, G in RGB
     */
    __publicField(this, "g", 0);
    /**
     * Blue, B in RGB
     */
    __publicField(this, "b", 0);
    /**
     * Alpha/Opacity, A in RGBA/HSLA
     */
    __publicField(this, "a", 1);
    // HSV privates
    __publicField(this, "_h");
    __publicField(this, "_hsl_s");
    __publicField(this, "_hsv_s");
    __publicField(this, "_l");
    __publicField(this, "_v");
    // intermediate variables to calculate HSL/HSV
    __publicField(this, "_max");
    __publicField(this, "_min");
    __publicField(this, "_brightness");
    function matchFormat(str) {
      return str[0] in input && str[1] in input && str[2] in input;
    }
    if (!input) ; else if (typeof input === "string") {
      let matchPrefix2 = function(prefix) {
        return trimStr.startsWith(prefix);
      };
      const trimStr = input.trim();
      if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) {
        this.fromHexString(trimStr);
      } else if (matchPrefix2("rgb")) {
        this.fromRgbString(trimStr);
      } else if (matchPrefix2("hsl")) {
        this.fromHslString(trimStr);
      } else if (matchPrefix2("hsv") || matchPrefix2("hsb")) {
        this.fromHsvString(trimStr);
      } else {
        const presetColor = presetColors_default[trimStr.toLowerCase()];
        if (presetColor) {
          this.fromHexString(
            // Convert 36 hex to 16 hex
            parseInt(presetColor, 36).toString(16).padStart(6, "0")
          );
        }
      }
    } else if (input instanceof _FastColor) {
      this.r = input.r;
      this.g = input.g;
      this.b = input.b;
      this.a = input.a;
      this._h = input._h;
      this._hsl_s = input._hsl_s;
      this._hsv_s = input._hsv_s;
      this._l = input._l;
      this._v = input._v;
    } else if (matchFormat("rgb")) {
      this.r = limitRange(input.r);
      this.g = limitRange(input.g);
      this.b = limitRange(input.b);
      this.a = typeof input.a === "number" ? limitRange(input.a, 1) : 1;
    } else if (matchFormat("hsl")) {
      this.fromHsl(input);
    } else if (matchFormat("hsv")) {
      this.fromHsv(input);
    } else {
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(input));
    }
  }
  // ======================= Setter =======================
  setR(value) {
    return this._sc("r", value);
  }
  setG(value) {
    return this._sc("g", value);
  }
  setB(value) {
    return this._sc("b", value);
  }
  setA(value) {
    return this._sc("a", value, 1);
  }
  setHue(value) {
    const hsv = this.toHsv();
    hsv.h = value;
    return this._c(hsv);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function adjustGamma(raw) {
      const val = raw / 255;
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }
    const R = adjustGamma(this.r);
    const G = adjustGamma(this.g);
    const B = adjustGamma(this.b);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  }
  getHue() {
    if (typeof this._h === "undefined") {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._h = 0;
      } else {
        this._h = round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
      }
    }
    return this._h;
  }
  /**
   * @deprecated should use getHSVSaturation or getHSLSaturation instead
   */
  getSaturation() {
    return this.getHSVSaturation();
  }
  getHSVSaturation() {
    if (typeof this._hsv_s === "undefined") {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._hsv_s = 0;
      } else {
        this._hsv_s = delta / this.getMax();
      }
    }
    return this._hsv_s;
  }
  getHSLSaturation() {
    if (typeof this._hsl_s === "undefined") {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._hsl_s = 0;
      } else {
        const l = this.getLightness();
        this._hsl_s = delta / 255 / (1 - Math.abs(2 * l - 1));
      }
    }
    return this._hsl_s;
  }
  getLightness() {
    if (typeof this._l === "undefined") {
      this._l = (this.getMax() + this.getMin()) / 510;
    }
    return this._l;
  }
  getValue() {
    if (typeof this._v === "undefined") {
      this._v = this.getMax() / 255;
    }
    return this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    if (typeof this._brightness === "undefined") {
      this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3;
    }
    return this._brightness;
  }
  // ======================== Func ========================
  darken(amount = 10) {
    const h = this.getHue();
    const s = this.getSaturation();
    let l = this.getLightness() - amount / 100;
    if (l < 0) {
      l = 0;
    }
    return this._c({
      h,
      s,
      l,
      a: this.a
    });
  }
  lighten(amount = 10) {
    const h = this.getHue();
    const s = this.getSaturation();
    let l = this.getLightness() + amount / 100;
    if (l > 1) {
      l = 1;
    }
    return this._c({
      h,
      s,
      l,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(input, amount = 50) {
    const color = this._c(input);
    const p = amount / 100;
    const calc = (key) => (color[key] - this[key]) * p + this[key];
    const rgba = {
      r: round(calc("r")),
      g: round(calc("g")),
      b: round(calc("b")),
      a: round(calc("a") * 100) / 100
    };
    return this._c(rgba);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(amount = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, amount);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(amount = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, amount);
  }
  onBackground(background) {
    const bg = this._c(background);
    const alpha = this.a + bg.a * (1 - this.a);
    const calc = (key) => {
      return round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
    };
    return this._c({
      r: calc("r"),
      g: calc("g"),
      b: calc("b"),
      a: alpha
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(other) {
    return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let hex = "#";
    const rHex = (this.r || 0).toString(16);
    hex += rHex.length === 2 ? rHex : "0" + rHex;
    const gHex = (this.g || 0).toString(16);
    hex += gHex.length === 2 ? gHex : "0" + gHex;
    const bHex = (this.b || 0).toString(16);
    hex += bHex.length === 2 ? bHex : "0" + bHex;
    if (typeof this.a === "number" && this.a >= 0 && this.a < 1) {
      const aHex = round(this.a * 255).toString(16);
      hex += aHex.length === 2 ? aHex : "0" + aHex;
    }
    return hex;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getHSLSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const h = this.getHue();
    const s = round(this.getHSLSaturation() * 100);
    const l = round(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getHSVSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(rgb, value, max) {
    const clone = this.clone();
    clone[rgb] = limitRange(value, max);
    return clone;
  }
  _c(input) {
    return new this.constructor(input);
  }
  getMax() {
    if (typeof this._max === "undefined") {
      this._max = Math.max(this.r, this.g, this.b);
    }
    return this._max;
  }
  getMin() {
    if (typeof this._min === "undefined") {
      this._min = Math.min(this.r, this.g, this.b);
    }
    return this._min;
  }
  fromHexString(trimStr) {
    const withoutPrefix = trimStr.replace("#", "");
    function connectNum(index1, index2) {
      return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
    }
    if (withoutPrefix.length < 6) {
      this.r = connectNum(0);
      this.g = connectNum(1);
      this.b = connectNum(2);
      this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
    } else {
      this.r = connectNum(0, 1);
      this.g = connectNum(2, 3);
      this.b = connectNum(4, 5);
      this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
    }
  }
  fromHsl({
    h: _h,
    s,
    l,
    a
  }) {
    const h = (_h % 360 + 360) % 360;
    this._h = h;
    this._hsl_s = s;
    this._l = l;
    this.a = typeof a === "number" ? a : 1;
    if (s <= 0) {
      const rgb = round(l * 255);
      this.r = rgb;
      this.g = rgb;
      this.b = rgb;
      return;
    }
    let r2 = 0, g = 0, b = 0;
    const huePrime = h / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * s;
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    if (huePrime >= 0 && huePrime < 1) {
      r2 = chroma;
      g = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
      r2 = secondComponent;
      g = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
      g = chroma;
      b = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
      g = secondComponent;
      b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
      r2 = secondComponent;
      b = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
      r2 = chroma;
      b = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    this.r = round((r2 + lightnessModification) * 255);
    this.g = round((g + lightnessModification) * 255);
    this.b = round((b + lightnessModification) * 255);
  }
  fromHsv({
    h: _h,
    s,
    v,
    a
  }) {
    const h = (_h % 360 + 360) % 360;
    this._h = h;
    this._hsv_s = s;
    this._v = v;
    this.a = typeof a === "number" ? a : 1;
    const vv = round(v * 255);
    this.r = vv;
    this.g = vv;
    this.b = vv;
    if (s <= 0) {
      return;
    }
    const hh = h / 60;
    const i = Math.floor(hh);
    const ff = hh - i;
    const p = round(v * (1 - s) * 255);
    const q = round(v * (1 - s * ff) * 255);
    const t = round(v * (1 - s * (1 - ff)) * 255);
    switch (i) {
      case 0:
        this.g = t;
        this.b = p;
        break;
      case 1:
        this.r = q;
        this.b = p;
        break;
      case 2:
        this.r = p;
        this.b = t;
        break;
      case 3:
        this.r = p;
        this.g = q;
        break;
      case 4:
        this.r = t;
        this.g = p;
        break;
      case 5:
      default:
        this.g = p;
        this.b = q;
        break;
    }
  }
  fromHsvString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsv({
      h: cells[0],
      s: cells[1],
      v: cells[2],
      a: cells[3]
    });
  }
  fromHslString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsl({
      h: cells[0],
      s: cells[1],
      l: cells[2],
      a: cells[3]
    });
  }
  fromRgbString(trimStr) {
    const cells = splitColorStr(trimStr, (num, txt) => (
      // Convert percentage to number. e.g. 50% -> 128
      txt.includes("%") ? round(num / 100 * 255) : num
    ));
    this.r = cells[0];
    this.g = cells[1];
    this.b = cells[2];
    this.a = cells[3];
  }
};

// ../../node_modules/@ant-design/colors/es/generate.js
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function getHue(hsv, i, light) {
  let hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i, light) {
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  let saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  }
  if (saturation > 1) {
    saturation = 1;
  }
  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Math.round(saturation * 100) / 100;
}
function getValue(hsv, i, light) {
  let value;
  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }
  value = Math.max(0, Math.min(1, value));
  return Math.round(value * 100) / 100;
}
function generate(color, opts = {}) {
  const patterns = [];
  const pColor = new FastColor(color);
  const hsv = pColor.toHsv();
  for (let i = lightColorCount; i > 0; i -= 1) {
    const c = new FastColor({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    });
    patterns.push(c);
  }
  patterns.push(pColor);
  for (let i = 1; i <= darkColorCount; i += 1) {
    const c = new FastColor({
      h: getHue(hsv, i),
      s: getSaturation(hsv, i),
      v: getValue(hsv, i)
    });
    patterns.push(c);
  }
  if (opts.theme === "dark") {
    return darkColorMap.map(({
      index,
      amount
    }) => new FastColor(opts.backgroundColor || "#141414").mix(patterns[index], amount).toHexString());
  }
  return patterns.map((c) => c.toHexString());
}
var blue = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
blue.primary = blue[5];

// ../../node_modules/@rc-component/util/es/Dom/canUseDom.js
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

// ../../node_modules/@rc-component/util/es/Dom/contains.js
function contains(root, n) {
  if (!root) {
    return false;
  }
  if (root.contains) {
    return root.contains(n);
  }
  let node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

// ../../node_modules/@rc-component/util/es/Dom/dynamicCSS.js
var APPEND_ORDER = "data-rc-order";
var APPEND_PRIORITY = "data-rc-priority";
var MARK_KEY = `rc-util-key`;
var containerCache = /* @__PURE__ */ new Map();
function getMark({
  mark
} = {}) {
  if (mark) {
    return mark.startsWith("data-") ? mark : `data-${mark}`;
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  const head = document.querySelector("head");
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === "queue") {
    return "prependQueue";
  }
  return prepend ? "prepend" : "append";
}
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter((node) => node.tagName === "STYLE");
}
function injectCSS(css, option = {}) {
  if (!canUseDom()) {
    return null;
  }
  const {
    csp,
    prepend,
    priority = 0
  } = option;
  const mergedOrder = getOrder(prepend);
  const isPrependQueue = mergedOrder === "prependQueue";
  const styleNode = document.createElement("style");
  styleNode.setAttribute(APPEND_ORDER, mergedOrder);
  if (isPrependQueue && priority) {
    styleNode.setAttribute(APPEND_PRIORITY, `${priority}`);
  }
  if (csp?.nonce) {
    styleNode.nonce = csp?.nonce;
  }
  styleNode.innerHTML = css;
  const container = getContainer(option);
  const {
    firstChild
  } = container;
  if (prepend) {
    if (isPrependQueue) {
      const existStyle = (option.styles || findStyles(container)).filter((node) => {
        if (!["prepend", "prependQueue"].includes(node.getAttribute(APPEND_ORDER))) {
          return false;
        }
        const nodePriority = Number(node.getAttribute(APPEND_PRIORITY) || 0);
        return priority >= nodePriority;
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key, option = {}) {
  let {
    styles
  } = option;
  styles || (styles = findStyles(getContainer(option)));
  return styles.find((node) => node.getAttribute(getMark(option)) === key);
}
function syncRealContainer(container, option) {
  const cachedRealContainer = containerCache.get(container);
  if (!cachedRealContainer || !contains(document, cachedRealContainer)) {
    const placeholderStyle = injectCSS("", option);
    const {
      parentNode
    } = placeholderStyle;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}
function updateCSS(css, key, originOption = {}) {
  const container = getContainer(originOption);
  const styles = findStyles(container);
  const option = {
    ...originOption,
    styles
  };
  syncRealContainer(container, option);
  const existNode = findExistNode(key, option);
  if (existNode) {
    if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) {
      existNode.nonce = option.csp?.nonce;
    }
    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }
    return existNode;
  }
  const newNode = injectCSS(css, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

// ../../node_modules/@rc-component/util/es/Dom/shadow.js
function getRoot(ele) {
  return ele?.getRootNode?.();
}
function inShadow(ele) {
  return getRoot(ele) instanceof ShadowRoot;
}
function getShadowRoot(ele) {
  return inShadow(ele) ? getRoot(ele) : null;
}

// ../../node_modules/@rc-component/util/es/warning.js
var warned = {};
var preWarningFns = [];
var preMessage = (fn) => {
  preWarningFns.push(fn);
};
function warning(valid, message) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    const finalMessage = preWarningFns.reduce((msg, preMessageFn) => preMessageFn(msg ?? "", "warning"), message);
    if (finalMessage) {
      console.error(`Warning: ${finalMessage}`);
    }
  }
}
function note(valid, message) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    const finalMessage = preWarningFns.reduce((msg, preMessageFn) => preMessageFn(msg ?? "", "note"), message);
    if (finalMessage) {
      console.warn(`Note: ${finalMessage}`);
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
function camelCase(input) {
  return input.replace(/-(.)/g, (match, g) => g.toUpperCase());
}
function warning2(valid, message) {
  warningOnce(valid, `[@ant-design/icons] ${message}`);
}
function isIconDefinition(target) {
  return typeof target === "object" && typeof target.name === "string" && typeof target.theme === "string" && (typeof target.icon === "object" || typeof target.icon === "function");
}
function normalizeAttrs(attrs = {}) {
  return Object.keys(attrs).reduce((acc, key) => {
    const val = attrs[key];
    switch (key) {
      case "class":
        acc.className = val;
        delete acc.class;
        break;
      default:
        delete acc[key];
        acc[camelCase(key)] = val;
    }
    return acc;
  }, {});
}
function generate2(node, key, rootProps) {
  if (!rootProps) {
    return /* @__PURE__ */ React3__default.createElement(node.tag, {
      key,
      ...normalizeAttrs(node.attrs)
    }, (node.children || []).map((child, index) => generate2(child, `${key}-${node.tag}-${index}`)));
  }
  return /* @__PURE__ */ React3__default.createElement(node.tag, {
    key,
    ...normalizeAttrs(node.attrs),
    ...rootProps
  }, (node.children || []).map((child, index) => generate2(child, `${key}-${node.tag}-${index}`)));
}
function getSecondaryColor(primaryColor) {
  return generate(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
var iconStyles = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin {
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
var useInsertStyles = (eleRef) => {
  const {
    csp,
    prefixCls,
    layer
  } = useContext(Context_default);
  let mergedStyleStr = iconStyles;
  if (prefixCls) {
    mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
  }
  if (layer) {
    mergedStyleStr = `@layer ${layer} {
${mergedStyleStr}
}`;
  }
  useEffect(() => {
    const ele = eleRef.current;
    const shadowRoot = getShadowRoot(ele);
    updateCSS(mergedStyleStr, "@ant-design-icons", {
      prepend: !layer,
      csp,
      attachTo: shadowRoot
    });
  }, []);
};

// ../../node_modules/@ant-design/icons/es/components/IconBase.js
var twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: false
};
function setTwoToneColors({
  primaryColor,
  secondaryColor
}) {
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return {
    ...twoToneColorPalette
  };
}
var IconBase = (props) => {
  const {
    icon,
    className,
    onClick,
    style,
    primaryColor,
    secondaryColor,
    ...restProps
  } = props;
  const svgRef = React3.useRef(null);
  let colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles(svgRef);
  warning2(isIconDefinition(icon), `icon should be icon definiton, but got ${icon}`);
  if (!isIconDefinition(icon)) {
    return null;
  }
  let target = icon;
  if (target && typeof target.icon === "function") {
    target = {
      ...target,
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    };
  }
  return generate2(target.icon, `svg-${target.name}`, {
    className,
    onClick,
    style,
    "data-icon": target.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ...restProps,
    ref: svgRef
  });
};
IconBase.displayName = "IconReact";
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var IconBase_default = IconBase;

// ../../node_modules/@ant-design/icons/es/components/twoTonePrimaryColor.js
function setTwoToneColor(twoToneColor) {
  const [primaryColor, secondaryColor] = normalizeTwoToneColors(twoToneColor);
  return IconBase_default.setTwoToneColors({
    primaryColor,
    secondaryColor
  });
}
function getTwoToneColor() {
  const colors = IconBase_default.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}

// ../../node_modules/@ant-design/icons/es/components/AntdIcon.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
setTwoToneColor(blue.primary);
var Icon = /* @__PURE__ */ React3.forwardRef((props, ref) => {
  const {
    // affect outter <i>...</i>
    className,
    // affect inner <svg>...</svg>
    icon,
    spin,
    rotate,
    tabIndex,
    onClick,
    // other
    twoToneColor,
    ...restProps
  } = props;
  const {
    prefixCls = "anticon",
    rootClassName
  } = React3.useContext(Context_default);
  const classString = clsx(rootClassName, prefixCls, {
    [`${prefixCls}-${icon.name}`]: !!icon.name,
    [`${prefixCls}-spin`]: !!spin || icon.name === "loading"
  }, className);
  let iconTabIndex = tabIndex;
  if (iconTabIndex === void 0 && onClick) {
    iconTabIndex = -1;
  }
  const svgStyle = rotate ? {
    msTransform: `rotate(${rotate}deg)`,
    transform: `rotate(${rotate}deg)`
  } : void 0;
  const [primaryColor, secondaryColor] = normalizeTwoToneColors(twoToneColor);
  return /* @__PURE__ */ React3.createElement("span", _extends({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref,
    tabIndex: iconTabIndex,
    onClick,
    className: classString
  }), /* @__PURE__ */ React3.createElement(IconBase_default, {
    icon,
    primaryColor,
    secondaryColor,
    style: svgStyle
  }));
});
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
if (process.env.NODE_ENV !== "production") {
  Icon.displayName = "AntdIcon";
}
var AntdIcon_default = Icon;

// ../../node_modules/@ant-design/icons-svg/es/asn/CheckOutlined.js
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlined_default = CheckOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CheckOutlined.js
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var CheckOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends2({}, props, {
  ref,
  icon: CheckOutlined_default
}));
var RefIcon = /* @__PURE__ */ React3.forwardRef(CheckOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon.displayName = "CheckOutlined";
}
var CheckOutlined_default2 = RefIcon;

// ../../node_modules/@ant-design/icons-svg/es/asn/CloseOutlined.js
var CloseOutlined = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, "name": "close", "theme": "outlined" };
var CloseOutlined_default = CloseOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CloseOutlined.js
function _extends3() {
  _extends3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
var CloseOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends3({}, props, {
  ref,
  icon: CloseOutlined_default
}));
var RefIcon2 = /* @__PURE__ */ React3.forwardRef(CloseOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon2.displayName = "CloseOutlined";
}
var CloseOutlined_default2 = RefIcon2;

// ../../node_modules/@ant-design/icons-svg/es/asn/DragOutlined.js
var DragOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z" } }] }, "name": "drag", "theme": "outlined" };
var DragOutlined_default = DragOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DragOutlined.js
function _extends4() {
  _extends4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
var DragOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends4({}, props, {
  ref,
  icon: DragOutlined_default
}));
var RefIcon3 = /* @__PURE__ */ React3.forwardRef(DragOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon3.displayName = "DragOutlined";
}
var DragOutlined_default2 = RefIcon3;

// ../../node_modules/@ant-design/icons-svg/es/asn/EditOutlined.js
var EditOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };
var EditOutlined_default = EditOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EditOutlined.js
function _extends5() {
  _extends5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends5.apply(this, arguments);
}
var EditOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends5({}, props, {
  ref,
  icon: EditOutlined_default
}));
var RefIcon4 = /* @__PURE__ */ React3.forwardRef(EditOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon4.displayName = "EditOutlined";
}
var EditOutlined_default2 = RefIcon4;

// ../../node_modules/@ant-design/icons-svg/es/asn/LeftOutlined.js
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
var LeftOutlined_default = LeftOutlined;

// ../../node_modules/@ant-design/icons/es/icons/LeftOutlined.js
function _extends6() {
  _extends6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends6.apply(this, arguments);
}
var LeftOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends6({}, props, {
  ref,
  icon: LeftOutlined_default
}));
var RefIcon5 = /* @__PURE__ */ React3.forwardRef(LeftOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon5.displayName = "LeftOutlined";
}
var LeftOutlined_default2 = RefIcon5;

// ../../node_modules/@ant-design/icons-svg/es/asn/RightOutlined.js
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlined_default = RightOutlined;

// ../../node_modules/@ant-design/icons/es/icons/RightOutlined.js
function _extends7() {
  _extends7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends7.apply(this, arguments);
}
var RightOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends7({}, props, {
  ref,
  icon: RightOutlined_default
}));
var RefIcon6 = /* @__PURE__ */ React3.forwardRef(RightOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon6.displayName = "RightOutlined";
}
var RightOutlined_default2 = RefIcon6;

// ../../node_modules/@ant-design/icons-svg/es/asn/SaveOutlined.js
var SaveOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z" } }] }, "name": "save", "theme": "outlined" };
var SaveOutlined_default = SaveOutlined;

// ../../node_modules/@ant-design/icons/es/icons/SaveOutlined.js
function _extends8() {
  _extends8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends8.apply(this, arguments);
}
var SaveOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends8({}, props, {
  ref,
  icon: SaveOutlined_default
}));
var RefIcon7 = /* @__PURE__ */ React3.forwardRef(SaveOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon7.displayName = "SaveOutlined";
}
var SaveOutlined_default2 = RefIcon7;

// ../../node_modules/@ant-design/icons-svg/es/asn/UnlockOutlined.js
var UnlockOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, "name": "unlock", "theme": "outlined" };
var UnlockOutlined_default = UnlockOutlined;

// ../../node_modules/@ant-design/icons/es/icons/UnlockOutlined.js
function _extends9() {
  _extends9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends9.apply(this, arguments);
}
var UnlockOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends9({}, props, {
  ref,
  icon: UnlockOutlined_default
}));
var RefIcon8 = /* @__PURE__ */ React3.forwardRef(UnlockOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon8.displayName = "UnlockOutlined";
}
var UnlockOutlined_default2 = RefIcon8;

// ../../node_modules/@ant-design/icons-svg/es/asn/ZoomInOutlined.js
var ZoomInOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };
var ZoomInOutlined_default = ZoomInOutlined;

// ../../node_modules/@ant-design/icons/es/icons/ZoomInOutlined.js
function _extends10() {
  _extends10 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends10.apply(this, arguments);
}
var ZoomInOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends10({}, props, {
  ref,
  icon: ZoomInOutlined_default
}));
var RefIcon9 = /* @__PURE__ */ React3.forwardRef(ZoomInOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon9.displayName = "ZoomInOutlined";
}
var ZoomInOutlined_default2 = RefIcon9;

// ../../node_modules/@ant-design/icons-svg/es/asn/ZoomOutOutlined.js
var ZoomOutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };
var ZoomOutOutlined_default = ZoomOutOutlined;

// ../../node_modules/@ant-design/icons/es/icons/ZoomOutOutlined.js
function _extends11() {
  _extends11 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends11.apply(this, arguments);
}
var ZoomOutOutlined2 = (props, ref) => /* @__PURE__ */ React3.createElement(AntdIcon_default, _extends11({}, props, {
  ref,
  icon: ZoomOutOutlined_default
}));
var RefIcon10 = /* @__PURE__ */ React3.forwardRef(ZoomOutOutlined2);
if (process.env.NODE_ENV !== "production") {
  RefIcon10.displayName = "ZoomOutOutlined";
}
var ZoomOutOutlined_default2 = RefIcon10;
function PdfViewer({ url, file, highlightedField, overlay }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const [pageWidth, setPageWidth] = useState(0);
  const [pageHeight, setPageHeight] = useState(0);
  const [error, setError] = useState(null);
  const scrollContainerRef = useRef(null);
  useEffect(() => {
    setPageNumber(1);
    setError(null);
  }, [url, file]);
  useEffect(() => {
    const fieldPage = highlightedField?.value?.page;
    if (fieldPage && fieldPage !== pageNumber) {
      setPageNumber(Math.max(1, Math.min(fieldPage, numPages || fieldPage)));
    }
  }, [highlightedField, numPages]);
  const prevCoordsRef = useRef("");
  useEffect(() => {
    if (!highlightedField?.value?.coordinates || !scrollContainerRef.current || !pageWidth || !pageHeight) {
      return;
    }
    const fieldPage = highlightedField.value.page;
    if (fieldPage && fieldPage !== pageNumber) {
      return;
    }
    const coords = highlightedField.value.coordinates;
    const coordsKey = `${coords.x},${coords.y},${coords.w},${coords.h}`;
    if (coordsKey === prevCoordsRef.current) {
      return;
    }
    prevCoordsRef.current = coordsKey;
    const pixelY = coords.y * pageHeight * scale;
    const pixelHeight = coords.h * pageHeight * scale;
    const boxCenterY = pixelY + pixelHeight / 2;
    const container = scrollContainerRef.current;
    const viewportHeight = container.clientHeight;
    const scrollTop = boxCenterY - viewportHeight / 2;
    container.scrollTo({
      top: Math.max(0, scrollTop),
      behavior: "smooth"
    });
  }, [highlightedField, pageWidth, pageHeight, scale]);
  function onDocumentLoadSuccess({ numPages: numPages2 }) {
    setNumPages(numPages2);
    setError(null);
  }
  function onDocumentLoadError(error2) {
    console.error("Error loading PDF:", error2);
    setError(error2.message);
  }
  function onPageLoadSuccess(page) {
    const viewport = page.getViewport({ scale: 1 });
    setPageWidth(viewport.width);
    setPageHeight(viewport.height);
  }
  function changePage(offset) {
    setPageNumber((prevPageNumber) => {
      const newPage = prevPageNumber + offset;
      return Math.max(1, Math.min(newPage, numPages || 1));
    });
  }
  function zoomIn() {
    setScale((prev) => Math.min(prev + 0.25, 3));
  }
  function zoomOut() {
    setScale((prev) => Math.max(prev - 0.25, 0.5));
  }
  function getBoundingBoxStyle(coordinates, isTemplateMatched) {
    if (!pageWidth || !pageHeight) return {};
    const buffer = isTemplateMatched ? 0 : 4;
    const pixelX = coordinates.x * pageWidth * scale - buffer;
    const pixelY = coordinates.y * pageHeight * scale - buffer;
    const pixelWidth = coordinates.w * pageWidth * scale + buffer * 2;
    const pixelHeight = coordinates.h * pageHeight * scale + buffer * 2;
    return {
      position: "absolute",
      left: `${pixelX}px`,
      top: `${pixelY}px`,
      width: `${pixelWidth}px`,
      height: `${pixelHeight}px`,
      border: "2px solid #1890ff",
      backgroundColor: "rgba(24, 144, 255, 0.1)",
      pointerEvents: "none",
      zIndex: 10
    };
  }
  if (error) {
    return /* @__PURE__ */ jsx(
      Alert,
      {
        message: "Error Loading PDF",
        description: error,
        type: "error",
        showIcon: true
      }
    );
  }
  if (!url && !file) {
    return /* @__PURE__ */ jsx(
      Alert,
      {
        message: "No PDF Document",
        description: "No PDF file or URL provided",
        type: "info",
        showIcon: true
      }
    );
  }
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          marginBottom: 16,
          padding: 12,
          background: "#fafafa",
          borderRadius: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        children: [
          /* @__PURE__ */ jsxs(Space, { children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                onClick: () => changePage(-1),
                disabled: pageNumber <= 1,
                size: "small",
                children: "Previous"
              }
            ),
            /* @__PURE__ */ jsxs("span", { children: [
              "Page ",
              pageNumber,
              " of ",
              numPages || "..."
            ] }),
            /* @__PURE__ */ jsx(
              Button,
              {
                onClick: () => changePage(1),
                disabled: pageNumber >= (numPages || 1),
                size: "small",
                children: "Next"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(Space, { children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                icon: /* @__PURE__ */ jsx(ZoomOutOutlined_default2, {}),
                onClick: zoomOut,
                disabled: scale <= 0.5,
                size: "small",
                children: "Zoom Out"
              }
            ),
            /* @__PURE__ */ jsxs("span", { children: [
              Math.round(scale * 100),
              "%"
            ] }),
            /* @__PURE__ */ jsx(
              Button,
              {
                icon: /* @__PURE__ */ jsx(ZoomInOutlined_default2, {}),
                onClick: zoomIn,
                disabled: scale >= 3,
                size: "small",
                children: "Zoom In"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: scrollContainerRef,
        style: {
          position: "relative",
          overflow: "auto",
          maxHeight: "70vh",
          border: "1px solid #d9d9d9",
          borderRadius: 4
        },
        children: /* @__PURE__ */ jsx(
          Document,
          {
            file: file || url,
            onLoadSuccess: onDocumentLoadSuccess,
            onLoadError: onDocumentLoadError,
            loading: /* @__PURE__ */ jsx("div", { style: { padding: 48, textAlign: "center" }, children: /* @__PURE__ */ jsx(Spin, { size: "large", tip: "Loading PDF..." }) }),
            children: /* @__PURE__ */ jsxs("div", { style: { position: "relative" }, children: [
              /* @__PURE__ */ jsx(
                Page,
                {
                  pageNumber,
                  scale,
                  onLoadSuccess: onPageLoadSuccess,
                  renderTextLayer: true,
                  renderAnnotationLayer: true
                }
              ),
              highlightedField && pageWidth && pageHeight && (!highlightedField.value?.page || highlightedField.value.page === pageNumber) && /* @__PURE__ */ jsxs(Fragment, { children: [
                highlightedField.label?.coordinates && /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      ...getBoundingBoxStyle(
                        highlightedField.label.coordinates,
                        highlightedField.label.isTemplateMatched
                      ),
                      borderColor: "#52c41a",
                      backgroundColor: "rgba(82, 196, 26, 0.1)"
                    },
                    title: `Label: ${highlightedField.label.data || "N/A"}`
                  }
                ),
                highlightedField.value?.coordinates && /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: getBoundingBoxStyle(
                      highlightedField.value.coordinates,
                      highlightedField.value.isTemplateMatched
                    ),
                    title: `Value: ${highlightedField.value.data || "N/A"}${highlightedField.value.isTemplateMatched ? " (template matched)" : ""}`
                  }
                )
              ] }),
              overlay && pageWidth > 0 && pageHeight > 0 && overlay({ pageNumber, pageWidth, pageHeight, scale })
            ] })
          }
        )
      }
    )
  ] });
}
var normalizeText = (text) => text.replace(/[\r\n]+/g, " ").replace(/\s+/g, " ").trim().toLowerCase();
var normalizeNumeric = (text) => {
  const cleaned = text.replace(/[$€£¥,\s]/g, "");
  const num = parseFloat(cleaned);
  if (!isNaN(num)) {
    const numericPattern = /^-?[\d.]+$/;
    if (numericPattern.test(cleaned) || numericPattern.test(cleaned.substring(0, num.toString().length + 3))) {
      return num.toFixed(2);
    }
  }
  return cleaned;
};
var textsMatch = (fieldText, compareValue) => {
  if (!fieldText || !compareValue) return false;
  if (fieldText === compareValue) return true;
  const normField = normalizeText(fieldText);
  const normCompare = normalizeText(compareValue);
  if (normField === normCompare) return true;
  const numField = normalizeNumeric(fieldText);
  const numCompare = normalizeNumeric(compareValue);
  if (numField && numCompare && numField === numCompare) return true;
  if (compareValue.includes("\n") && normCompare.length >= 20) {
    if (normField.includes(normCompare) || normCompare.includes(normField))
      return true;
  }
  return false;
};
var ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?Z?)?$/;
var isIsoDateLike = (value) => ISO_DATE_RE.test(value);
var levenshteinDistance = (str1, str2) => {
  const len1 = str1.length;
  const len2 = str2.length;
  const matrix = [];
  for (let i = 0; i <= len1; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= len2; j++) {
    matrix[0][j] = j;
  }
  for (let i = 1; i <= len1; i++) {
    for (let j = 1; j <= len2; j++) {
      if (str1[i - 1] === str2[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          // substitution
          matrix[i][j - 1] + 1,
          // insertion
          matrix[i - 1][j] + 1
          // deletion
        );
      }
    }
  }
  return matrix[len1][len2];
};
var calculateMatchScore = (fieldText, semanticValue, originalText, formattedDateValue) => {
  if (!fieldText || !semanticValue) return 0;
  const normField = normalizeText(fieldText);
  const normSemantic = normalizeText(semanticValue);
  const normOriginal = normalizeText(originalText);
  if (fieldText === semanticValue) return 1e3;
  if (fieldText === originalText) return 950;
  if (formattedDateValue && fieldText === formattedDateValue) return 900;
  if (normField === normSemantic) return 800;
  if (normField === normOriginal) return 750;
  if (formattedDateValue && normField === normalizeText(formattedDateValue))
    return 700;
  const numField = normalizeNumeric(fieldText);
  const numSemantic = normalizeNumeric(semanticValue);
  const numOriginal = normalizeNumeric(originalText);
  if (numField && numSemantic && numField === numSemantic) {
    const lengthRatio = fieldText.length / semanticValue.toString().length;
    if (lengthRatio <= 1.5) {
      return 600;
    } else {
      return 300;
    }
  }
  if (numField && numOriginal && numField === numOriginal) {
    const lengthRatio = fieldText.length / originalText.length;
    return lengthRatio <= 1.5 ? 550 : 250;
  }
  if (semanticValue.includes("\n") && normSemantic.length >= 20) {
    if (normField.includes(normSemantic)) return 400;
    if (normSemantic.includes(normField)) return 350;
  }
  if (normField.includes(normSemantic) && normSemantic.length >= 3) {
    const lengthRatio = fieldText.length / semanticValue.length;
    const baseScore = lengthRatio <= 1.5 ? 200 : 100;
    const distance = levenshteinDistance(normField, normSemantic);
    const maxLength = Math.max(normField.length, normSemantic.length);
    const similarity = 1 - distance / maxLength;
    return baseScore + Math.floor(similarity * 100);
  }
  if (normSemantic.includes(normField) && normField.length >= 3) {
    const lengthRatio = fieldText.length / semanticValue.length;
    const baseScore = lengthRatio <= 1.5 ? 150 : 75;
    const distance = levenshteinDistance(normSemantic, normField);
    const maxLength = Math.max(normField.length, normSemantic.length);
    const similarity = 1 - distance / maxLength;
    return baseScore + Math.floor(similarity * 100);
  }
  return 0;
};
function findHighlightedField(params) {
  const {
    hoveredFieldKey,
    fields,
    documentData,
    dateFormat,
    blocks,
    verificationData
  } = params;
  if (!hoveredFieldKey || !fields) {
    return null;
  }
  const fieldVerification = verificationData[hoveredFieldKey];
  const effectiveFieldKey = fieldVerification?.validated === "fixed" && fieldVerification?.fixKey && fieldVerification.fixKey !== "MANUAL_ENTRY" && fieldVerification.fixKey !== "DELETE_MAPPING" ? fieldVerification.fixKey : hoveredFieldKey;
  let fieldValue = fieldVerification?.isLineItem ? fields.lineItems?.[0]?.[effectiveFieldKey] : fields[effectiveFieldKey];
  if (!fieldValue && effectiveFieldKey.startsWith("line___") && fields.lineItems?.[0]) {
    fieldValue = fields.lineItems[0][effectiveFieldKey];
  }
  if (!fieldValue) {
    const isFixedField = fieldVerification?.validated === "fixed";
    const semanticValue = isFixedField ? verificationData[hoveredFieldKey]?.value : documentData?.lineItems?.[0]?.[hoveredFieldKey] ?? documentData?.[hoveredFieldKey] ?? verificationData[hoveredFieldKey]?.value;
    if (semanticValue) {
      const semanticStr = semanticValue.toString();
      const originalFieldValue = fields[hoveredFieldKey];
      const originalText = originalFieldValue?.text || semanticStr;
      let formattedDateValue = null;
      if (isIsoDateLike(semanticStr) && dateFormat) {
        try {
          const parsed = parseISO(semanticStr);
          if (isValid(parsed)) {
            formattedDateValue = format(parsed, dateFormat);
          }
        } catch {
        }
      }
      const fieldTextMatches = (rawFieldValue) => {
        const txt = typeof rawFieldValue === "object" && rawFieldValue && "text" in rawFieldValue ? rawFieldValue.text : rawFieldValue;
        if (!txt) return false;
        const s = txt.toString();
        return textsMatch(s, semanticStr) || textsMatch(s, originalText) || Boolean(formattedDateValue && textsMatch(s, formattedDateValue));
      };
      if (!isFixedField) {
        const headerFieldsWithMatchingTemplate = [];
        for (const [, value] of Object.entries(fields)) {
          if (typeof value === "object" && value && "templateField" in value) {
            if (value.templateField === hoveredFieldKey) {
              if (fieldTextMatches(value)) {
                fieldValue = value;
                break;
              }
              headerFieldsWithMatchingTemplate.push(value);
            }
          }
        }
        if (!fieldValue && headerFieldsWithMatchingTemplate.length > 0) {
          fieldValue = headerFieldsWithMatchingTemplate[0];
        }
        if (!fieldValue && fields.lineItems?.[0]) {
          const lineFieldsWithMatchingTemplate = [];
          for (const [, value] of Object.entries(fields.lineItems[0])) {
            if (typeof value === "object" && value && "templateField" in value) {
              if (value.templateField === hoveredFieldKey) {
                if (fieldTextMatches(value)) {
                  fieldValue = value;
                  break;
                }
                lineFieldsWithMatchingTemplate.push(value);
              }
            }
          }
          if (!fieldValue && lineFieldsWithMatchingTemplate.length > 0) {
            fieldValue = lineFieldsWithMatchingTemplate[0];
          }
        }
      }
      if (!fieldValue || isFixedField) {
        const extractText = (value) => {
          if (!value) return "";
          if (typeof value === "string") return value;
          if (typeof value === "object" && "text" in value) {
            return String(value.text);
          }
          return "";
        };
        const isLineItemField = fieldVerification?.isLineItem === true;
        let bestScore = 0;
        let bestMatch = null;
        for (const [key, value] of Object.entries(fields)) {
          if (key === "lineItems") continue;
          const txt = extractText(value);
          if (txt) {
            let score = calculateMatchScore(
              txt,
              semanticStr,
              originalText,
              formattedDateValue
            );
            if (!isLineItemField && score >= 200) {
              score += 1e3;
            }
            if (score > bestScore) {
              bestScore = score;
              bestMatch = value;
            }
          }
        }
        if (fields.lineItems?.[0]) {
          for (const [, value] of Object.entries(fields.lineItems[0])) {
            const txt = extractText(value);
            if (txt) {
              let score = calculateMatchScore(
                txt,
                semanticStr,
                originalText,
                formattedDateValue
              );
              if (isLineItemField) {
                score += 50;
              }
              if (score > bestScore) {
                bestScore = score;
                bestMatch = value;
              }
            }
          }
        }
        if (blocks && blocks.length > 0) {
          for (const block of blocks) {
            if ((block.BlockType === "LINE" || block.BlockType === "WORD") && block.Text && block.Geometry?.BoundingBox) {
              const score = calculateMatchScore(
                block.Text,
                semanticStr,
                originalText,
                formattedDateValue
              );
              if (score > bestScore) {
                bestScore = score;
                bestMatch = {
                  text: block.Text,
                  boundingBox: block.Geometry.BoundingBox,
                  page: block.Page
                };
              }
            }
          }
        }
        if (bestMatch) {
          fieldValue = bestMatch;
        }
      }
    }
  }
  if (!fieldValue || typeof fieldValue !== "object" || !("boundingBox" in fieldValue) || !fieldValue.boundingBox) {
    return null;
  }
  const { boundingBox } = fieldValue;
  if (typeof boundingBox.Height !== "number" || typeof boundingBox.Left !== "number" || typeof boundingBox.Top !== "number" || typeof boundingBox.Width !== "number") {
    return null;
  }
  const text = typeof fieldValue === "object" && "text" in fieldValue ? fieldValue.text : "";
  const isTemplateMatched = !!fieldValue?.templateField && fieldValue?.templateField === hoveredFieldKey && fieldVerification?.validated !== "fixed";
  const result = {
    value: {
      coordinates: {
        x: boundingBox.Left,
        y: boundingBox.Top,
        w: boundingBox.Width,
        h: boundingBox.Height
      },
      data: text || null,
      isTemplateMatched,
      page: fieldValue?.page
    }
  };
  return result;
}
var { TextArea } = Input;
var { Title, Text } = Typography;
var extractFieldText = (value) => {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object" && "text" in value) {
    return String(value.text);
  }
  return "";
};
var NumberOfLinesCard = ({
  field,
  verificationData,
  setVerificationData,
  handleFieldValidation,
  PoLineItemsFields
}) => {
  const [inputValue, setInputValue] = useState("");
  return /* @__PURE__ */ jsxs(
    Card,
    {
      size: "small",
      style: { marginBottom: 8 },
      styles: { body: { padding: "12px" } },
      children: [
        /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "top", gutter: 8, children: [
          /* @__PURE__ */ jsxs(Col, { span: 16, children: [
            /* @__PURE__ */ jsx(Text, { type: "secondary", style: { fontSize: "12px" }, children: field.label }),
            /* @__PURE__ */ jsx("br", {}),
            /* @__PURE__ */ jsx(Text, { strong: true, style: { fontSize: "13px" }, children: field.value || "Not found" })
          ] }),
          /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(Space, { size: "small", children: [
            field.validated === "fixed" ? /* @__PURE__ */ jsx(
              Tag,
              {
                color: "success",
                icon: /* @__PURE__ */ jsx(CheckOutlined_default2, {}),
                style: { margin: 0 },
                children: "Fixed"
              }
            ) : /* @__PURE__ */ jsx(
              Button,
              {
                type: field.validated === "ok" ? "primary" : "default",
                size: "small",
                icon: /* @__PURE__ */ jsx(CheckOutlined_default2, {}),
                onClick: () => handleFieldValidation("numberOfLines", "ok"),
                children: "OK"
              }
            ),
            field.validated !== "fixed" && /* @__PURE__ */ jsx(
              Button,
              {
                danger: field.validated === "wrong",
                size: "small",
                icon: /* @__PURE__ */ jsx(CloseOutlined_default2, {}),
                onClick: () => handleFieldValidation("numberOfLines", "wrong"),
                children: "Wrong"
              }
            ),
            field.validated === "fixed" && /* @__PURE__ */ jsx(
              Button,
              {
                size: "small",
                onClick: () => {
                  setVerificationData((prev) => ({
                    ...prev,
                    numberOfLines: {
                      ...prev.numberOfLines,
                      value: prev.numberOfLines.originalValue,
                      validated: "unchecked",
                      fixKey: ""
                    }
                  }));
                },
                children: "Reset"
              }
            )
          ] }) })
        ] }),
        field.showFix && /* @__PURE__ */ jsxs("div", { style: { marginTop: 12 }, children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              size: "small",
              type: "number",
              min: 0,
              style: { width: "100%" },
              value: inputValue,
              onChange: (e) => setInputValue(e.target.value),
              placeholder: "Enter number of lines"
            }
          ),
          /* @__PURE__ */ jsxs(Space, { size: "small", style: { marginTop: 8 }, children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                type: "primary",
                size: "small",
                disabled: !inputValue.trim(),
                onClick: () => {
                  const numValue = parseInt(inputValue.trim()) || 0;
                  setVerificationData((prev) => {
                    const updated = { ...prev };
                    updated.numberOfLines = {
                      ...prev.numberOfLines,
                      fixKey: "MANUAL_ENTRY",
                      value: String(numValue),
                      showFix: false,
                      validated: "fixed"
                    };
                    Object.keys(PoLineItemsFields).forEach((key) => {
                      if (prev[key] && prev[key].isLineItem && prev[key].originalOtherValues) {
                        const original = prev[key].originalOtherValues;
                        updated[key] = {
                          ...prev[key],
                          otherValues: Array.from(
                            { length: numValue },
                            (_, i) => original[i] || ""
                          )
                        };
                      }
                    });
                    return updated;
                  });
                },
                children: "Apply"
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                size: "small",
                onClick: () => {
                  setVerificationData((prev) => ({
                    ...prev,
                    numberOfLines: {
                      ...prev.numberOfLines,
                      showFix: false,
                      fixKey: ""
                    }
                  }));
                  setInputValue("");
                },
                children: "Cancel"
              }
            )
          ] })
        ] })
      ]
    },
    "numberOfLines"
  );
};
var VerificationSummary = ({
  verificationData,
  PoHeaderFields,
  PoLineItemsFields,
  editingLineIndex,
  setEditingLineIndex,
  setVerificationData,
  onReverify,
  canClaim,
  onClaim,
  claiming
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        padding: "16px",
        overflowY: "auto",
        flex: 1,
        minHeight: 0
      },
      children: [
        /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", style: { marginBottom: 12 }, children: [
          /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Title, { level: 5, style: { margin: 0 }, children: "Verification Summary" }) }),
          /* @__PURE__ */ jsx(Col, { children: canClaim ? /* @__PURE__ */ jsx(
            Button,
            {
              type: "primary",
              icon: /* @__PURE__ */ jsx(UnlockOutlined_default2, {}),
              loading: claiming,
              onClick: onClaim,
              children: "Claim to verify"
            }
          ) : /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(EditOutlined_default2, {}), onClick: onReverify, children: "Re-verify / Remap" }) })
        ] }),
        /* @__PURE__ */ jsx(
          Card,
          {
            size: "small",
            title: "Document Details",
            style: { marginBottom: 12, fontSize: "13px" },
            children: /* @__PURE__ */ jsx(Row, { gutter: [8, 8], children: Object.keys(PoHeaderFields).map((key) => /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsxs(Text, { style: { fontSize: "13px" }, children: [
              /* @__PURE__ */ jsxs("strong", { children: [
                PoHeaderFields[key].label,
                ":"
              ] }),
              " ",
              verificationData[key]?.value || "-"
            ] }) }, key)) })
          }
        ),
        Object.keys(PoLineItemsFields).length > 0 && /* @__PURE__ */ jsx(
          Card,
          {
            size: "small",
            title: `Line Items (${verificationData.numberOfLines?.value || 0} items)`,
            children: /* @__PURE__ */ jsxs(
              "table",
              {
                style: {
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "12px"
                },
                children: [
                  /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { style: { borderBottom: "1px solid #e1e3e5" }, children: [
                    /* @__PURE__ */ jsx(
                      "th",
                      {
                        style: {
                          textAlign: "center",
                          padding: "8px",
                          width: "40px"
                        }
                      }
                    ),
                    Object.keys(PoLineItemsFields).map((key) => /* @__PURE__ */ jsx(
                      "th",
                      {
                        style: {
                          textAlign: ["qty", "price", "total"].includes(key) ? "right" : "left",
                          padding: "8px"
                        },
                        children: PoLineItemsFields[key].label
                      },
                      key
                    ))
                  ] }) }),
                  /* @__PURE__ */ jsx("tbody", { children: Array.from(
                    {
                      length: Number(verificationData.numberOfLines?.value || 0)
                    },
                    (_, index) => {
                      return /* @__PURE__ */ jsxs(
                        "tr",
                        {
                          style: { borderBottom: "1px solid #f1f2f3" },
                          children: [
                            /* @__PURE__ */ jsx("td", { style: { padding: "4px", textAlign: "center" }, children: /* @__PURE__ */ jsx(
                              Button,
                              {
                                type: "text",
                                size: "small",
                                icon: editingLineIndex === index ? /* @__PURE__ */ jsx(SaveOutlined_default2, {}) : /* @__PURE__ */ jsx(EditOutlined_default2, {}),
                                onClick: () => setEditingLineIndex(
                                  editingLineIndex === index ? null : index
                                )
                              }
                            ) }),
                            Object.keys(PoLineItemsFields).map((key) => {
                              const fieldType = PoLineItemsFields[key]?.type;
                              const isNumeric = ["currency", "decimal"].includes(
                                fieldType
                              );
                              const isLongText = fieldType === "string" && ["desc", "description"].includes(key);
                              const maxWidth = isLongText ? "200px" : isNumeric ? "100px" : "120px";
                              return /* @__PURE__ */ jsx(
                                "td",
                                {
                                  style: {
                                    padding: "4px",
                                    maxWidth,
                                    textAlign: isNumeric ? "right" : "left"
                                  },
                                  children: editingLineIndex === index ? /* @__PURE__ */ jsx(
                                    TextArea,
                                    {
                                      size: "small",
                                      autoSize: { minRows: 1, maxRows: 3 },
                                      style: {
                                        width: "100%",
                                        fontSize: "12px",
                                        textAlign: isNumeric ? "right" : "left"
                                      },
                                      value: verificationData[key]?.otherValues?.[index] || "",
                                      onChange: (e) => {
                                        const value = e.target.value;
                                        const updated = {
                                          ...verificationData
                                        };
                                        if (!updated[key].otherValues) {
                                          updated[key].otherValues = [
                                            ...updated[key].originalOtherValues || []
                                          ];
                                        }
                                        updated[key].otherValues[index] = value;
                                        updated[key].validated = "fixed";
                                        setVerificationData(updated);
                                      }
                                    }
                                  ) : /* @__PURE__ */ jsx(
                                    "div",
                                    {
                                      style: {
                                        wordBreak: isLongText ? "break-word" : "normal",
                                        fontSize: "12px"
                                      },
                                      children: verificationData[key]?.otherValues?.[index] || "-"
                                    }
                                  )
                                },
                                key
                              );
                            })
                          ]
                        },
                        index
                      );
                    }
                  ) })
                ]
              }
            )
          }
        )
      ]
    }
  );
};
var FieldVerificationCard = ({
  fieldKey,
  field,
  dateFormat,
  documentData,
  fields,
  deselectedOptions,
  verificationData,
  readOnly,
  setVerificationData,
  handleFieldHover,
  handleFieldValidation,
  PoLineItemsFields,
  transformValue,
  fieldToolsPanel
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(deselectedOptions);
  const [selectedOption, setSelectedOption] = useState();
  const [validationError, setValidationError] = useState(null);
  const isInteractingRef = useRef(false);
  const escapeSpecialRegExCharacters = useCallback(
    (value) => value?.toString()?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
    []
  );
  const validateInput = useCallback(
    (value) => {
      const fieldType = field.type;
      if (fieldType === "datetime") {
        if (!dateFormat) {
          return { isValid: true, error: null };
        }
        try {
          const parsedDate = parse(value, dateFormat, /* @__PURE__ */ new Date());
          if (isValid(parsedDate) && parsedDate.getFullYear() > 1900) {
            return { isValid: true, error: null };
          }
        } catch {
        }
        return {
          isValid: false,
          error: `Invalid date format. Expected: ${dateFormat.toUpperCase()}`
        };
      }
      if (fieldType === "currency" || fieldType === "decimal") {
        const cleaned = value.replace(/[$€£¥,\s]/g, "");
        const num = parseFloat(cleaned);
        if (isNaN(num)) {
          return {
            isValid: false,
            error: `Invalid ${fieldType === "currency" ? "currency" : "number"} format`
          };
        }
      }
      return { isValid: true, error: null };
    },
    [field.type, dateFormat]
  );
  const updateText = useCallback(
    (value) => {
      const matchedByKey = deselectedOptions.find((opt) => opt.value === value);
      const displayValue = matchedByKey ? matchedByKey.label : value;
      setInputValue(displayValue);
      setValidationError(null);
      if (displayValue === "") {
        setFilteredOptions(deselectedOptions);
        setSelectedOption(void 0);
        return;
      }
      const filterRegex = new RegExp(
        escapeSpecialRegExCharacters(displayValue),
        "i"
      );
      const resultOptions = deselectedOptions.filter(
        (option) => option.label.match(filterRegex)
      );
      setFilteredOptions(resultOptions);
      if (displayValue.trim()) {
        const validation = validateInput(displayValue.trim());
        if (!validation.isValid) {
          setValidationError(validation.error);
        }
      }
    },
    [deselectedOptions, escapeSpecialRegExCharacters, validateInput]
  );
  const handleSelectOption = useCallback(
    (value) => {
      const matchedOption = deselectedOptions.find(
        (opt) => opt.value === value
      );
      if (matchedOption) {
        setSelectedOption(value);
        setInputValue(matchedOption.label);
      }
    },
    [deselectedOptions]
  );
  return /* @__PURE__ */ jsxs(
    Card,
    {
      size: "small",
      style: { marginBottom: 8 },
      styles: { body: { padding: "12px" } },
      onMouseEnter: () => {
        if (!isInteractingRef.current) {
          handleFieldHover(fieldKey);
        }
      },
      children: [
        /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "top", gutter: 8, children: [
          /* @__PURE__ */ jsxs(Col, { span: 16, children: [
            /* @__PURE__ */ jsx(Text, { type: "secondary", style: { fontSize: "12px" }, children: field.label }),
            /* @__PURE__ */ jsx("br", {}),
            /* @__PURE__ */ jsxs(Text, { strong: true, style: { fontSize: "13px" }, children: [
              field.value || "Not found",
              field.type === "datetime" && dateFormat && ` (${dateFormat.toUpperCase()})`
            ] })
          ] }),
          /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(Space, { size: "small", children: [
            field.validated === "fixed" ? /* @__PURE__ */ jsx(
              Tag,
              {
                color: "success",
                icon: /* @__PURE__ */ jsx(CheckOutlined_default2, {}),
                style: { margin: 0 },
                children: "Fixed"
              }
            ) : /* @__PURE__ */ jsx(
              Button,
              {
                type: field.validated === "ok" ? "primary" : "default",
                size: "small",
                icon: /* @__PURE__ */ jsx(CheckOutlined_default2, {}),
                onClick: () => handleFieldValidation(fieldKey, "ok"),
                children: "OK"
              }
            ),
            field.validated !== "fixed" && /* @__PURE__ */ jsx(
              Button,
              {
                danger: field.validated === "wrong",
                size: "small",
                icon: /* @__PURE__ */ jsx(CloseOutlined_default2, {}),
                onClick: () => handleFieldValidation(fieldKey, "wrong"),
                children: "Wrong"
              }
            ),
            field.validated === "fixed" && /* @__PURE__ */ jsx(
              Button,
              {
                size: "small",
                onClick: () => {
                  setVerificationData((prev) => {
                    const updated = {
                      ...prev,
                      [fieldKey]: {
                        ...prev[fieldKey],
                        value: prev[fieldKey].originalValue,
                        validated: "unchecked",
                        fixKey: ""
                      }
                    };
                    if (prev[fieldKey].isLineItem && prev[fieldKey].originalOtherValues) {
                      updated[fieldKey].otherValues = [
                        ...prev[fieldKey].originalOtherValues
                      ];
                    }
                    return updated;
                  });
                },
                children: "Reset"
              }
            )
          ] }) })
        ] }),
        field.showFix && /* @__PURE__ */ jsxs("div", { style: { marginTop: 12 }, children: [
          deselectedOptions.length === 1 && deselectedOptions[0].value === "" ? /* @__PURE__ */ jsx(
            Text,
            {
              type: "secondary",
              style: { display: "block", marginBottom: 6, fontSize: "12px" },
              children: "No alternative values found in the document. You can enter a value manually below."
            }
          ) : null,
          /* @__PURE__ */ jsx(
            AutoComplete,
            {
              size: "small",
              style: { width: "100%" },
              options: filteredOptions,
              value: inputValue,
              onChange: updateText,
              onSelect: handleSelectOption,
              onFocus: () => {
                isInteractingRef.current = true;
              },
              onBlur: () => {
                isInteractingRef.current = false;
              },
              placeholder: field.type === "datetime" && dateFormat ? `Search or enter date (${dateFormat.toUpperCase()})` : "Search correct value or enter manually",
              status: validationError ? "error" : void 0,
              getPopupContainer: (trigger) => trigger.parentElement || document.body
            }
          ),
          validationError && /* @__PURE__ */ jsx(
            Text,
            {
              type: "danger",
              style: { display: "block", marginTop: 4, fontSize: "12px" },
              children: validationError
            }
          ),
          field.type === "datetime" && dateFormat && !validationError && /* @__PURE__ */ jsxs(
            Text,
            {
              type: "secondary",
              style: { display: "block", marginTop: 4, fontSize: "12px" },
              children: [
                "Expected format: ",
                dateFormat.toUpperCase()
              ]
            }
          ),
          /* @__PURE__ */ jsxs(Space, { size: "small", style: { marginTop: 8 }, children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                type: "primary",
                size: "small",
                disabled: !selectedOption,
                onClick: () => {
                  const matchedOption = deselectedOptions.find(
                    (opt) => opt.value === selectedOption
                  );
                  if (matchedOption) {
                    setVerificationData((prev) => {
                      const updated = {
                        ...prev,
                        [fieldKey]: {
                          ...prev[fieldKey],
                          fixKey: selectedOption || "MANUAL_ENTRY",
                          value: matchedOption.label,
                          showFix: false,
                          validated: "fixed"
                        }
                      };
                      if (prev[fieldKey].isLineItem && selectedOption) {
                        updated[fieldKey].otherValues = prev[fieldKey].otherValues?.map(
                          (_item, index) => {
                            let value = "";
                            const textractField = fields?.lineItems?.[index]?.[selectedOption];
                            if (textractField) {
                              value = textractField?.text || textractField || "";
                            } else {
                              value = documentData.lineItems?.[index]?.[selectedOption] || "";
                            }
                            return transformValue(value, prev[fieldKey].type);
                          }
                        ) || [];
                      }
                      return updated;
                    });
                  }
                },
                children: "Apply Selected"
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                size: "small",
                disabled: !inputValue.trim() || !!selectedOption || !!validationError,
                onClick: () => {
                  const validation = validateInput(inputValue.trim());
                  if (!validation.isValid) {
                    setValidationError(validation.error);
                    return;
                  }
                  setVerificationData((prev) => {
                    const updated = {
                      ...prev,
                      [fieldKey]: {
                        ...prev[fieldKey],
                        fixKey: "MANUAL_ENTRY",
                        value: inputValue.trim(),
                        showFix: false,
                        validated: "fixed"
                      }
                    };
                    if (fieldKey === "numberOfLines") {
                      const numValue = parseInt(inputValue.trim()) || 0;
                      Object.keys(PoLineItemsFields).forEach((key) => {
                        if (prev[key].isLineItem && prev[key].originalOtherValues) {
                          const original = prev[key].originalOtherValues;
                          updated[key].otherValues = Array.from(
                            { length: numValue },
                            (_, i) => original[i] || ""
                          );
                        }
                      });
                    }
                    if (prev[fieldKey].isLineItem) {
                      const lineItemCount = documentData.lineItems?.length || 0;
                      updated[fieldKey].otherValues = Array(lineItemCount).fill(
                        inputValue.trim()
                      );
                    }
                    return updated;
                  });
                },
                children: "Use Manual Entry"
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                size: "small",
                onClick: () => {
                  setVerificationData((prev) => ({
                    ...prev,
                    [fieldKey]: {
                      ...prev[fieldKey],
                      showFix: false,
                      fixKey: "",
                      validated: "unchecked"
                    }
                  }));
                  setValidationError(null);
                  setInputValue("");
                },
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                danger: true,
                size: "small",
                onClick: () => {
                  setVerificationData((prev) => {
                    const updated = {
                      ...prev,
                      [fieldKey]: {
                        ...prev[fieldKey],
                        value: "",
                        fixKey: "DELETE_MAPPING",
                        showFix: false,
                        validated: "fixed"
                      }
                    };
                    if (prev[fieldKey].isLineItem) {
                      const lineItemCount = documentData.lineItems?.length || 0;
                      updated[fieldKey].otherValues = Array(lineItemCount).fill("");
                    }
                    return updated;
                  });
                },
                children: "Not in the Document"
              }
            )
          ] })
        ] }),
        !readOnly && field.validated === "wrong" && fieldToolsPanel && /* @__PURE__ */ jsx("div", { style: { marginTop: 12 }, children: fieldToolsPanel(fieldKey, field) })
      ]
    },
    fieldKey
  );
};
function MappingVerificationWizard({
  mappingKey,
  pdfHash,
  pdfUrl,
  docType,
  api,
  onComplete,
  onError,
  mappingStatus: initialMappingStatus,
  processing = false,
  mappingOwner: initialMappingOwner,
  currentUserId,
  onClaim,
  onRelease,
  initialData,
  advancedTabContent,
  fieldToolsPanel,
  dateFormat: dateFormatProp,
  pdfOverlay,
  suppressHighlight
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [verifying, setVerifying] = useState(false);
  const [claiming, setClaiming] = useState(false);
  const [verificationError, setVerificationError] = useState(null);
  const [releasing, setReleasing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editingLineIndex, setEditingLineIndex] = useState(null);
  const [hoveredFieldKey, setHoveredFieldKey] = useState(null);
  const [mappingStatus, setMappingStatus] = useState(
    initialMappingStatus?.toLocaleUpperCase() || ""
  );
  const [mappingOwner, setMappingOwner] = useState(initialMappingOwner);
  const CLAIMABLE_STATUSES = ["NEW", "AUTO_MAPPING", "COMPLETED"];
  const ACTIVE_STATUSES = ["IN_PROGRESS", "IN_VERIFICATION"];
  const initialStatus = initialMappingStatus?.toLocaleUpperCase() ?? "";
  const [showSummary, setShowSummary] = useState(
    initialStatus === "VERIFIED" || CLAIMABLE_STATUSES.includes(initialStatus)
  );
  const canClaim = !processing && CLAIMABLE_STATUSES.includes(mappingStatus);
  const isOwnedByOther = ACTIVE_STATUSES.includes(mappingStatus) && !!mappingOwner && mappingOwner !== currentUserId;
  const isReadOnly = isOwnedByOther || processing || CLAIMABLE_STATUSES.includes(mappingStatus);
  const handleClaim = async () => {
    setClaiming(true);
    try {
      setMappingStatus("IN_VERIFICATION");
      setMappingOwner(currentUserId);
      setShowSummary(false);
      setCurrentStep(0);
      onClaim?.();
    } catch (err) {
      onError?.(err);
    } finally {
      setClaiming(false);
    }
  };
  const [data, setData] = useState(null);
  const [fields, setFields] = useState({});
  const [dateFormat, setDateFormat] = useState(dateFormatProp ?? "");
  const [blocks, setBlocks] = useState([]);
  const firstValue = data ? Object.values(data)[0] : null;
  const documentData = firstValue?.data?.[0] ?? {};
  React3__default.useEffect(() => {
    const loadData = async () => {
      if (initialData) {
        setData(initialData.data);
        setFields(initialData.fields);
        setDateFormat(initialData.dateFormat);
        setBlocks(initialData.blocks || []);
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const mappingData = await api.getMappingData(mappingKey, pdfHash);
        setData(mappingData.data);
        setFields(mappingData.fields);
        setDateFormat(mappingData.dateFormat);
        setBlocks(mappingData.blocks || []);
      } catch (err) {
        onError?.(err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [mappingKey, pdfHash, api, onError, initialData]);
  const mapDataTypeToFieldType = (dataTypeName) => {
    switch (dataTypeName) {
      case "STRING":
        return "string";
      case "DECIMAL":
      case "NUMBER":
        return "currency";
      // Treat all numeric/decimal fields as currency (with formatting)
      case "DATE":
        return "datetime";
      case "ADDRESS":
        return "address";
      default:
        return "string";
    }
  };
  const PoHeaderFields = useMemo(() => {
    const fields2 = {};
    docType.dataFields?.filter((field) => field.dataType?.name !== "TABLE").forEach((field) => {
      if (!field.dataType?.name) return;
      const fieldType = mapDataTypeToFieldType(field.dataType.name);
      fields2[field.fieldName] = {
        type: fieldType,
        label: field.displayName || field.fieldName
      };
    });
    return fields2;
  }, [docType]);
  const PoLineItemsFields = useMemo(() => {
    const fields2 = {};
    const tableField = docType.dataFields?.find(
      (field) => field.dataType?.name === "TABLE"
    );
    if (tableField?.columns) {
      tableField.columns.forEach((column) => {
        if (!column.dataType?.name) return;
        const fieldType = mapDataTypeToFieldType(column.dataType.name);
        fields2[column.fieldName] = {
          type: fieldType,
          label: column.displayName || column.fieldName
        };
      });
    }
    return fields2;
  }, [docType]);
  const transformValue = (value, fieldType) => {
    if (!value) return "";
    switch (fieldType) {
      case "currency":
      case "decimal": {
        const cleaned = value?.toString()?.replace(/[$€£¥,\s]/g, "");
        const num = parseFloat(cleaned);
        return isNaN(num) ? value : num.toFixed(2);
      }
      case "datetime": {
        if (dateFormat) {
          try {
            const parsedDate = parse(value, dateFormat, /* @__PURE__ */ new Date());
            if (isValid(parsedDate)) {
              return format(parsedDate, dateFormat);
            }
          } catch {
          }
        }
        try {
          const isoDate = parseISO(value);
          if (isValid(isoDate) && isoDate.getFullYear() > 1900) {
            return dateFormat ? format(isoDate, dateFormat) : value;
          }
        } catch {
        }
        return value;
      }
      default:
        return value;
    }
  };
  const isNumericValue = (value) => {
    if (!value) return false;
    const cleaned = value?.toString()?.replace(/[$€£¥,\s]/g, "");
    return !isNaN(Number(cleaned)) && cleaned !== "";
  };
  const isDateTimeValue = (value) => {
    if (!value) return false;
    if (dateFormat) {
      try {
        const parsedDate = parse(value, dateFormat, /* @__PURE__ */ new Date());
        if (isValid(parsedDate) && parsedDate.getFullYear() > 1900) {
          return true;
        }
      } catch {
        return false;
      }
    }
    const date = new Date(value);
    return !isNaN(date.getTime()) && date.getFullYear() > 1900 && value.length > 4;
  };
  const headerFieldOptions = useMemo(() => {
    return fields ? Object.keys(fields)?.filter((key) => key !== "lineItems" && fields[key]).map((key) => ({
      label: extractFieldText(fields[key]),
      value: key
    })) : [];
  }, [fields]);
  const lineFieldOptions = useMemo(() => {
    return fields?.lineItems?.[0] ? Object.keys(fields.lineItems[0])?.filter((key) => fields.lineItems[0][key]).map((key) => ({
      label: extractFieldText(fields.lineItems[0][key]),
      value: key
    })) : [];
  }, [fields]);
  const options = (fieldKey, alternatives, isLine = false) => {
    const current = isLine ? transformValue(
      documentData?.lineItems?.[0]?.[fieldKey],
      PoLineItemsFields[fieldKey]?.type
    ) : transformValue(
      documentData?.[fieldKey],
      PoHeaderFields[fieldKey]?.type
    );
    const defaultOption = { label: current, value: "" };
    return isLine ? documentData?.lineItems && documentData.lineItems.length > 0 ? [
      defaultOption,
      ...Object.keys(documentData.lineItems[0]).filter(
        (op) => alternatives.includes(op) && documentData.lineItems[0][op]
      ).map((op) => ({
        label: transformValue(
          documentData.lineItems[0][op],
          PoLineItemsFields[op]?.type
        ),
        value: op
      })) ?? []
    ] : [] : [
      defaultOption,
      ...Object.keys(documentData).filter((op) => alternatives.includes(op) && documentData[op]).map((op) => ({
        label: transformValue(documentData[op], PoHeaderFields[op]?.type),
        value: op
      })) ?? []
    ];
  };
  const getFilteredLineOptions = (options2, fieldType) => {
    return options2.filter((option) => {
      if (!option.label) return false;
      if (fieldType === "currency" || fieldType === "decimal") {
        return isNumericValue(option.label);
      }
      if (fieldType === "datetime") {
        return isDateTimeValue(option.label);
      }
      return true;
    }).map((option) => ({
      ...option,
      label: transformValue(option.label, fieldType)
    }));
  };
  const filterUniqueOptions = (alternativeOptions, fieldOptions) => {
    const alternativeLabels = new Set(
      alternativeOptions.map((opt) => opt.label)
    );
    const uniqueFieldOptions = fieldOptions.filter(
      (opt) => !alternativeLabels.has(opt.label)
    );
    return [...alternativeOptions, ...uniqueFieldOptions];
  };
  const optionsMap = useMemo(() => {
    const map = {};
    Object.keys(PoHeaderFields).forEach((fieldKey) => {
      const field = PoHeaderFields[fieldKey];
      if (!field) return;
      if (fieldKey === "earliestDate" || fieldKey === "latestDate") {
        const otherDateField = fieldKey === "earliestDate" ? "latestDate" : "earliestDate";
        map[fieldKey] = getFilteredLineOptions(
          filterUniqueOptions(
            options(fieldKey, [otherDateField]),
            headerFieldOptions
          ),
          field.type
        );
      } else if (fieldKey === "deliverTo") {
        map[fieldKey] = getFilteredLineOptions(
          filterUniqueOptions(
            options(fieldKey, ["invoiceTo"]),
            headerFieldOptions
          ),
          field.type
        );
      } else if (fieldKey === "deliveryInstructions") {
        map[fieldKey] = headerFieldOptions;
      } else {
        map[fieldKey] = getFilteredLineOptions(
          headerFieldOptions,
          field.type
        );
      }
    });
    Object.keys(PoLineItemsFields).forEach((fieldKey) => {
      const field = PoLineItemsFields[fieldKey];
      if (!field) return;
      if (fieldKey === "code") {
        map[fieldKey] = getFilteredLineOptions(
          filterUniqueOptions(
            options(fieldKey, ["ean", "customerCode", "lineItemNo"], true),
            lineFieldOptions
          ),
          field.type
        );
      } else if (fieldKey === "customerCode") {
        map[fieldKey] = getFilteredLineOptions(
          filterUniqueOptions(
            options(fieldKey, ["ean", "code", "lineItemNo"], true),
            lineFieldOptions
          ),
          field.type
        );
      } else if (fieldKey === "price") {
        map[fieldKey] = getFilteredLineOptions(
          filterUniqueOptions(
            options(fieldKey, ["total", "discount"], true),
            lineFieldOptions
          ),
          field.type
        );
      } else if (fieldKey === "total") {
        map[fieldKey] = getFilteredLineOptions(
          filterUniqueOptions(
            options(fieldKey, ["price", "discount"], true),
            lineFieldOptions
          ),
          field.type
        );
      } else if (fieldKey === "desc" || fieldKey === "uom") {
        map[fieldKey] = lineFieldOptions;
      } else {
        map[fieldKey] = getFilteredLineOptions(lineFieldOptions, field.type);
      }
    });
    return map;
  }, [
    headerFieldOptions,
    lineFieldOptions,
    documentData,
    PoHeaderFields,
    PoLineItemsFields
  ]);
  const getFieldOptions = (fieldKey) => {
    return optionsMap[fieldKey] && optionsMap[fieldKey].length > 0 ? optionsMap[fieldKey] : [{ label: "No options available", value: "" }];
  };
  const [verificationData, setVerificationData] = useState({});
  React3__default.useEffect(() => {
    if (dateFormatProp !== void 0) setDateFormat(dateFormatProp);
  }, [dateFormatProp]);
  React3__default.useEffect(() => {
    if (!data) return;
    const initial = {};
    const isVerified = ["VERIFIED", "COMPLETED", "IN_VERIFICATION"].includes(
      mappingStatus
    );
    Object.keys(PoHeaderFields).forEach((key) => {
      initial[key] = {
        type: PoHeaderFields[key].type,
        label: PoHeaderFields[key].label,
        value: transformValue(documentData[key], PoHeaderFields[key].type),
        originalValue: transformValue(
          documentData[key],
          PoHeaderFields[key].type
        ),
        validated: isVerified ? "ok" : "unchecked",
        showFix: false,
        fixKey: "",
        isLineItem: false
      };
    });
    Object.keys(PoLineItemsFields).forEach((key) => {
      initial[key] = {
        type: PoLineItemsFields[key].type,
        label: PoLineItemsFields[key].label,
        value: transformValue(
          documentData.lineItems?.[0]?.[key],
          PoLineItemsFields[key].type
        ),
        originalValue: transformValue(
          documentData.lineItems?.[0]?.[key],
          PoLineItemsFields[key].type
        ),
        validated: isVerified ? "ok" : "unchecked",
        showFix: false,
        fixKey: "",
        isLineItem: true,
        otherValues: documentData.lineItems?.map(
          (item) => transformValue(item[key], PoLineItemsFields[key].type)
        ) || [],
        originalOtherValues: documentData.lineItems?.map(
          (item) => transformValue(item[key], PoLineItemsFields[key].type)
        ) || []
      };
    });
    initial.numberOfLines = {
      type: "number",
      label: "Number of Lines",
      value: String(documentData.lineItems?.length ?? 0),
      originalValue: String(documentData.lineItems?.length ?? 0),
      validated: isVerified ? "ok" : "unchecked",
      showFix: false,
      fixKey: "",
      isLineItem: false
    };
    setVerificationData(initial);
  }, [data, mappingStatus]);
  const hoverTimeoutRef = useRef(null);
  const handleFieldHover = useCallback((fieldKey) => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    hoverTimeoutRef.current = setTimeout(() => {
      setHoveredFieldKey(fieldKey);
    }, 200);
  }, []);
  const highlightedField = useMemo(
    () => findHighlightedField({
      hoveredFieldKey,
      fields,
      documentData,
      dateFormat,
      blocks,
      verificationData
    }),
    [
      hoveredFieldKey,
      fields,
      documentData,
      dateFormat,
      blocks,
      verificationData
    ]
  );
  const handleFieldValidation = (fieldKey, validation) => {
    setVerificationData((prev) => ({
      ...prev,
      [fieldKey]: {
        ...prev[fieldKey],
        validated: validation,
        showFix: validation === "wrong"
      }
    }));
  };
  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, 2));
  };
  const handlePrev = () => {
    setVerificationError(null);
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };
  const handleSubmit = async () => {
    setVerifying(true);
    setVerificationError(null);
    try {
      const payload = {
        dexRuleSetId: "",
        pdfHash,
        data: verificationData
      };
      const result = await api.verifyMapping(mappingKey, payload);
      setMappingStatus("VERIFIED");
      setShowSummary(true);
      onComplete?.(result);
    } catch (error) {
      const responseData = error?.response?.data;
      if (error?.response?.status === 422 && responseData?.cannotExtract) {
        setVerificationError({ cannotExtract: responseData.cannotExtract });
      } else {
        console.error("Verification failed:", error);
        onError?.(error);
      }
    } finally {
      setVerifying(false);
    }
  };
  const handleReverify = () => {
    setShowSummary(false);
    setVerificationError(null);
    setCurrentStep(0);
  };
  const isStepValid = (step) => {
    if (step === 0) {
      return Object.keys(PoHeaderFields).every(
        (key) => verificationData[key]?.validated !== "unchecked"
      );
    }
    if (step === 1) {
      return Object.keys(PoLineItemsFields).every(
        (key) => verificationData[key]?.validated !== "unchecked"
      ) && verificationData.numberOfLines?.validated !== "unchecked";
    }
    if (step === 2) {
      const headerDone = Object.keys(PoHeaderFields).every(
        (key) => verificationData[key]?.validated !== "unchecked"
      );
      const linesDone = Object.keys(PoLineItemsFields).every(
        (key) => verificationData[key]?.validated !== "unchecked"
      ) && verificationData.numberOfLines?.validated !== "unchecked";
      return headerDone && linesDone;
    }
    return true;
  };
  React3__default.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        return;
      }
      if (event.key === "ArrowLeft" && currentStep > 0) {
        event.preventDefault();
        handlePrev();
      } else if (event.key === "ArrowRight" && currentStep < 2 && isStepValid(currentStep)) {
        event.preventDefault();
        handleNext();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [currentStep]);
  const getFieldDisplayLabel = (fieldPath) => {
    if (PoHeaderFields[fieldPath]) return PoHeaderFields[fieldPath].label;
    const match = fieldPath.match(/lineItems\[(\d+)\]\.(.+)/);
    if (match) {
      const rowIndex = parseInt(match[1]);
      const col = match[2];
      return `Line item ${rowIndex + 1} \u2014 ${PoLineItemsFields[col]?.label ?? col}`;
    }
    return fieldPath;
  };
  if (loading) {
    return /* @__PURE__ */ jsx("div", { style: { textAlign: "center", padding: "100px 0" }, children: /* @__PURE__ */ jsx(Typography.Text, { children: "Loading mapping data..." }) });
  }
  if (!data || !fields || Object.keys(verificationData).length === 0) {
    return /* @__PURE__ */ jsx("div", { style: { textAlign: "center", padding: "100px 0" }, children: /* @__PURE__ */ jsx(Typography.Text, { type: "danger", children: "Failed to load mapping data" }) });
  }
  return /* @__PURE__ */ jsxs("div", { style: { height: "100%", display: "flex", flexDirection: "column" }, children: [
    /* @__PURE__ */ jsxs(Splitter, { style: { height: "85vh", flex: "0 0 auto" }, children: [
      /* @__PURE__ */ jsx(Splitter.Panel, { defaultSize: "60%", min: "40%", max: "80%", children: pdfUrl && /* @__PURE__ */ jsx(
        PdfViewer,
        {
          url: pdfUrl,
          highlightedField: suppressHighlight ? null : highlightedField,
          overlay: pdfOverlay
        }
      ) }),
      /* @__PURE__ */ jsxs(
        Splitter.Panel,
        {
          style: {
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
          },
          children: [
            (!showSummary || advancedTabContent) && /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  padding: "0 16px",
                  flexShrink: 0,
                  gap: 4
                },
                children: [
                  !showSummary && [
                    { index: 0, label: "1. Document" },
                    { index: 1, label: "2. Line Items" },
                    { index: 2, label: "3. Review" }
                  ].map(({ index, label }) => /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: () => setCurrentStep(index),
                      style: {
                        padding: "8px 12px",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        borderBottom: currentStep === index ? "2px solid #1890ff" : "2px solid transparent",
                        color: currentStep === index ? "#1890ff" : "#666",
                        fontWeight: currentStep === index ? 600 : 400,
                        fontSize: 13,
                        marginBottom: -1,
                        whiteSpace: "nowrap"
                      },
                      children: label
                    },
                    index
                  )),
                  advancedTabContent && !isReadOnly && /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: () => {
                        setShowSummary(false);
                        setCurrentStep(3);
                      },
                      style: {
                        padding: "8px 12px",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        borderBottom: currentStep === 3 && !showSummary ? "2px solid #722ed1" : "2px solid transparent",
                        color: currentStep === 3 && !showSummary ? "#722ed1" : "#666",
                        fontWeight: currentStep === 3 && !showSummary ? 600 : 400,
                        fontSize: 13,
                        marginBottom: -1,
                        whiteSpace: "nowrap"
                      },
                      children: "\u2699 Advanced"
                    }
                  )
                ]
              }
            ),
            isOwnedByOther && /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  padding: "6px 16px",
                  background: "#fffbe6",
                  borderBottom: "1px solid #ffe58f",
                  fontSize: 12,
                  color: "#ad6800",
                  flexShrink: 0
                },
                children: [
                  "This mapping is currently claimed by",
                  " ",
                  /* @__PURE__ */ jsx("strong", { children: mappingOwner }),
                  ". You can view it in read-only mode."
                ]
              }
            ),
            verificationError && /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  padding: "10px 16px",
                  background: "#fff2f0",
                  borderBottom: "1px solid #ffccc7",
                  flexShrink: 0
                },
                children: /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "flex-start", gap: 8 }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#ff4d4f", fontSize: 14, lineHeight: "20px" }, children: "\u2715" }),
                  /* @__PURE__ */ jsxs("div", { style: { flex: 1, fontSize: 13 }, children: [
                    /* @__PURE__ */ jsx("strong", { style: { color: "#cf1322" }, children: "Verification could not be completed." }),
                    " ",
                    "Please",
                    " ",
                    /* @__PURE__ */ jsx("strong", { children: "raise a support ticket" }),
                    " ",
                    "so our team can investigate.",
                    verificationError.cannotExtract && verificationError.cannotExtract.length > 0 && /* @__PURE__ */ jsx(
                      Collapse,
                      {
                        size: "small",
                        ghost: true,
                        style: { marginTop: 4 },
                        items: [{
                          key: "details",
                          label: /* @__PURE__ */ jsx(Text, { type: "secondary", style: { fontSize: 12 }, children: "Show details for support ticket" }),
                          children: /* @__PURE__ */ jsx("ul", { style: { paddingLeft: 16, margin: 0, fontSize: 12 }, children: verificationError.cannotExtract.map((f, i) => /* @__PURE__ */ jsxs("li", { style: { marginBottom: 4 }, children: [
                            /* @__PURE__ */ jsxs("strong", { children: [
                              getFieldDisplayLabel(f.field),
                              ":"
                            ] }),
                            " ",
                            "expected ",
                            /* @__PURE__ */ jsxs("em", { children: [
                              '"',
                              f.expected,
                              '"'
                            ] }),
                            ", found ",
                            /* @__PURE__ */ jsxs("em", { children: [
                              '"',
                              f.extracted || "nothing",
                              '"'
                            ] })
                          ] }, i)) })
                        }]
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: () => setVerificationError(null),
                      style: { background: "none", border: "none", cursor: "pointer", color: "#ff4d4f", fontSize: 16, lineHeight: 1, padding: 0 },
                      children: "\xD7"
                    }
                  )
                ] })
              }
            ),
            showSummary ? /* @__PURE__ */ jsx(
              VerificationSummary,
              {
                verificationData,
                PoHeaderFields,
                PoLineItemsFields,
                editingLineIndex,
                setEditingLineIndex,
                setVerificationData,
                onReverify: handleReverify,
                canClaim,
                onClaim: handleClaim,
                claiming
              }
            ) : /* @__PURE__ */ jsxs(Fragment, { children: [
              currentStep === 0 && /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    padding: "16px",
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0
                  },
                  children: [
                    /* @__PURE__ */ jsx(Title, { level: 5, style: { marginTop: 0, marginBottom: 12 }, children: "Step 1: Verify Document Information" }),
                    Object.keys(PoHeaderFields).map((key) => /* @__PURE__ */ jsx(
                      FieldVerificationCard,
                      {
                        fieldKey: key,
                        field: verificationData[key],
                        dateFormat,
                        documentData,
                        fields,
                        deselectedOptions: getFieldOptions(key),
                        verificationData,
                        setVerificationData,
                        handleFieldHover,
                        handleFieldValidation,
                        PoLineItemsFields,
                        transformValue,
                        readOnly: isReadOnly,
                        fieldToolsPanel: fieldToolsPanel ? (fk, fv) => fieldToolsPanel(
                          fk,
                          fv,
                          docType.dataFields?.find(
                            (f) => f.fieldName === fk
                          ),
                          () => findHighlightedField({
                            hoveredFieldKey: fk,
                            fields,
                            documentData,
                            dateFormat,
                            blocks,
                            verificationData
                          })?.value.coordinates ?? null
                        ) : void 0
                      },
                      key
                    ))
                  ]
                }
              ),
              currentStep === 1 && /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    padding: "16px",
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0
                  },
                  children: [
                    /* @__PURE__ */ jsx(Title, { level: 5, style: { marginTop: 0, marginBottom: 12 }, children: "Step 2: Verify Line Items" }),
                    /* @__PURE__ */ jsx(
                      NumberOfLinesCard,
                      {
                        field: verificationData.numberOfLines,
                        verificationData,
                        setVerificationData,
                        handleFieldValidation,
                        PoLineItemsFields
                      }
                    ),
                    /* @__PURE__ */ jsx(Divider, { style: { margin: "12px 0" } }),
                    /* @__PURE__ */ jsx(Text, { strong: true, style: { fontSize: "13px" }, children: "Line Item 1 Fields:" }),
                    /* @__PURE__ */ jsx("div", { style: { marginTop: 12 }, children: Object.keys(PoLineItemsFields).map((key) => /* @__PURE__ */ jsx(
                      FieldVerificationCard,
                      {
                        fieldKey: key,
                        field: verificationData[key],
                        dateFormat,
                        documentData,
                        fields,
                        deselectedOptions: getFieldOptions(key),
                        verificationData,
                        setVerificationData,
                        handleFieldHover,
                        handleFieldValidation,
                        PoLineItemsFields,
                        transformValue,
                        readOnly: false
                      },
                      key
                    )) })
                  ]
                }
              ),
              currentStep === 2 && /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    padding: "16px",
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0
                  },
                  children: [
                    /* @__PURE__ */ jsx(Title, { level: 5, style: { marginTop: 0, marginBottom: 12 }, children: "Step 3: Review Summary" }),
                    /* @__PURE__ */ jsx(
                      Card,
                      {
                        size: "small",
                        title: "Document Details",
                        style: { marginBottom: 12, fontSize: "13px" },
                        children: /* @__PURE__ */ jsx(Row, { gutter: [8, 8], children: Object.keys(PoHeaderFields).map((key) => /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsxs(Text, { style: { fontSize: "13px" }, children: [
                          /* @__PURE__ */ jsxs("strong", { children: [
                            PoHeaderFields[key].label,
                            ":"
                          ] }),
                          " ",
                          verificationData[key]?.value
                        ] }) }, key)) })
                      }
                    ),
                    Object.keys(PoLineItemsFields).length > 0 && /* @__PURE__ */ jsx(
                      Card,
                      {
                        size: "small",
                        title: `Line Items (${verificationData.numberOfLines?.value} items)`,
                        children: /* @__PURE__ */ jsxs(
                          "table",
                          {
                            style: {
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: "12px"
                            },
                            children: [
                              /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { style: { borderBottom: "1px solid #e1e3e5" }, children: [
                                /* @__PURE__ */ jsx(
                                  "th",
                                  {
                                    style: {
                                      textAlign: "center",
                                      padding: "8px",
                                      width: "40px"
                                    }
                                  }
                                ),
                                Object.keys(PoLineItemsFields).map((key) => /* @__PURE__ */ jsx(
                                  "th",
                                  {
                                    style: {
                                      textAlign: ["qty", "price", "total"].includes(
                                        key
                                      ) ? "right" : "left",
                                      padding: "8px"
                                    },
                                    children: PoLineItemsFields[key].label
                                  },
                                  key
                                ))
                              ] }) }),
                              /* @__PURE__ */ jsx("tbody", { children: Array.from(
                                {
                                  length: Number(
                                    verificationData.numberOfLines?.value || 0
                                  )
                                },
                                (_, index) => {
                                  return /* @__PURE__ */ jsxs(
                                    "tr",
                                    {
                                      style: { borderBottom: "1px solid #f1f2f3" },
                                      children: [
                                        /* @__PURE__ */ jsx(
                                          "td",
                                          {
                                            style: {
                                              padding: "4px",
                                              textAlign: "center"
                                            },
                                            children: /* @__PURE__ */ jsx(
                                              Button,
                                              {
                                                type: "text",
                                                size: "small",
                                                icon: editingLineIndex === index ? /* @__PURE__ */ jsx(SaveOutlined_default2, {}) : /* @__PURE__ */ jsx(EditOutlined_default2, {}),
                                                onClick: () => setEditingLineIndex(
                                                  editingLineIndex === index ? null : index
                                                )
                                              }
                                            )
                                          }
                                        ),
                                        Object.keys(PoLineItemsFields).map((key) => {
                                          const fieldType = PoLineItemsFields[key]?.type;
                                          const isNumeric = [
                                            "currency",
                                            "decimal"
                                          ].includes(fieldType);
                                          const isLongText = fieldType === "string" && ["desc", "description"].includes(key);
                                          const maxWidth = isLongText ? "200px" : isNumeric ? "100px" : "120px";
                                          return /* @__PURE__ */ jsx(
                                            "td",
                                            {
                                              style: {
                                                padding: "4px",
                                                maxWidth,
                                                textAlign: isNumeric ? "right" : "left"
                                              },
                                              children: editingLineIndex === index ? /* @__PURE__ */ jsx(
                                                TextArea,
                                                {
                                                  size: "small",
                                                  autoSize: {
                                                    minRows: 1,
                                                    maxRows: 3
                                                  },
                                                  style: {
                                                    width: "100%",
                                                    fontSize: "12px",
                                                    textAlign: isNumeric ? "right" : "left"
                                                  },
                                                  value: verificationData[key]?.otherValues?.[index] || "",
                                                  onChange: (e) => {
                                                    const value = e.target.value;
                                                    const updated = {
                                                      ...verificationData
                                                    };
                                                    if (!updated[key].otherValues) {
                                                      updated[key].otherValues = [
                                                        ...updated[key].originalOtherValues || []
                                                      ];
                                                    }
                                                    updated[key].otherValues[index] = value;
                                                    updated[key].validated = "fixed";
                                                    setVerificationData(updated);
                                                  }
                                                }
                                              ) : /* @__PURE__ */ jsx(
                                                "div",
                                                {
                                                  style: {
                                                    wordBreak: isLongText ? "break-word" : "normal",
                                                    fontSize: "12px"
                                                  },
                                                  children: verificationData[key]?.otherValues?.[index] || "-"
                                                }
                                              )
                                            },
                                            key
                                          );
                                        })
                                      ]
                                    },
                                    index
                                  );
                                }
                              ) })
                            ]
                          }
                        )
                      }
                    )
                  ]
                }
              ),
              currentStep === 3 && advancedTabContent && /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    padding: "16px",
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0
                  },
                  children: advancedTabContent
                }
              )
            ] })
          ]
        }
      )
    ] }),
    !showSummary && currentStep !== 3 && /* @__PURE__ */ jsx(
      Card,
      {
        size: "small",
        style: {
          position: "sticky",
          bottom: 0,
          zIndex: 10,
          borderTop: "1px solid #f0f0f0",
          boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.08)",
          backgroundColor: "white"
        },
        styles: { body: { padding: "12px 16px" } },
        children: /* @__PURE__ */ jsxs(Row, { justify: "space-between", children: [
          /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(
            Button,
            {
              size: "middle",
              onClick: handlePrev,
              disabled: currentStep === 0,
              icon: /* @__PURE__ */ jsx(LeftOutlined_default2, {}),
              children: "Previous"
            }
          ) }),
          /* @__PURE__ */ jsx(Col, { children: currentStep < 2 ? /* @__PURE__ */ jsxs(
            Button,
            {
              size: "middle",
              type: "primary",
              onClick: handleNext,
              disabled: !isStepValid(currentStep),
              children: [
                "Next ",
                /* @__PURE__ */ jsx(RightOutlined_default2, {})
              ]
            }
          ) : /* @__PURE__ */ jsx(
            Button,
            {
              size: "middle",
              type: "primary",
              onClick: handleSubmit,
              loading: verifying,
              disabled: !isStepValid(2),
              children: "Submit Verification"
            }
          ) })
        ] })
      }
    )
  ] });
}
var HANDLE_SIZE = 10;
var MIN_SIZE = 8;
function EditableBox({
  fieldKey,
  label,
  box,
  draggable,
  selected,
  onSelect,
  onChange
}) {
  const boxRef = useRef(null);
  const onDragStart = useCallback(
    (e) => {
      if (!draggable) return;
      e.stopPropagation();
      onSelect(fieldKey);
      const startX = e.clientX;
      const startY = e.clientY;
      const startLeft = box.left;
      const startTop = box.top;
      const onMove = (me) => {
        onChange(fieldKey, {
          ...box,
          left: startLeft + me.clientX - startX,
          top: startTop + me.clientY - startY
        });
      };
      const onUp = () => {
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
      };
      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
    },
    [draggable, box, fieldKey, onChange, onSelect]
  );
  const onResizeStart = useCallback(
    (e, corner) => {
      if (!draggable) return;
      e.stopPropagation();
      e.preventDefault();
      const startX = e.clientX;
      const startY = e.clientY;
      const { left, top, width, height } = box;
      const onMove = (me) => {
        const dx = me.clientX - startX;
        const dy = me.clientY - startY;
        let newLeft = left, newTop = top, newW = width, newH = height;
        if (corner === "se") {
          newW = Math.max(MIN_SIZE, width + dx);
          newH = Math.max(MIN_SIZE, height + dy);
        }
        if (corner === "sw") {
          newLeft = left + dx;
          newW = Math.max(MIN_SIZE, width - dx);
          newH = Math.max(MIN_SIZE, height + dy);
        }
        if (corner === "ne") {
          newTop = top + dy;
          newW = Math.max(MIN_SIZE, width + dx);
          newH = Math.max(MIN_SIZE, height - dy);
        }
        if (corner === "nw") {
          newLeft = left + dx;
          newTop = top + dy;
          newW = Math.max(MIN_SIZE, width - dx);
          newH = Math.max(MIN_SIZE, height - dy);
        }
        onChange(fieldKey, { left: newLeft, top: newTop, width: newW, height: newH });
      };
      const onUp = () => {
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
      };
      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
    },
    [draggable, box, fieldKey, onChange]
  );
  const color = selected ? "#1890ff" : "#722ed1";
  const bg = selected ? "rgba(24,144,255,0.12)" : "rgba(114,46,209,0.08)";
  const cursor = draggable ? "move" : "not-allowed";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: boxRef,
      onPointerDown: onDragStart,
      onClick: (e) => {
        e.stopPropagation();
        onSelect(fieldKey);
      },
      style: {
        position: "absolute",
        left: box.left,
        top: box.top,
        width: box.width,
        height: box.height,
        border: `2px solid ${color}`,
        backgroundColor: bg,
        cursor,
        zIndex: selected ? 20 : 15,
        boxSizing: "border-box",
        userSelect: "none"
      },
      children: [
        /* @__PURE__ */ jsx(Tooltip, { title: draggable ? "Drag to move" : "Pattern field \u2014 edit pattern to reposition", children: /* @__PURE__ */ jsxs(
          Tag,
          {
            color: selected ? "blue" : "purple",
            style: {
              position: "absolute",
              top: "100%",
              marginTop: 2,
              left: 0,
              fontSize: 10,
              lineHeight: "16px",
              padding: "0 4px",
              cursor,
              whiteSpace: "nowrap",
              maxWidth: 120,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            children: [
              draggable && /* @__PURE__ */ jsx(DragOutlined_default2, { style: { marginRight: 2 } }),
              label
            ]
          }
        ) }),
        draggable && ["se", "sw", "ne", "nw"].map((corner) => /* @__PURE__ */ jsx(
          "div",
          {
            onPointerDown: (e) => onResizeStart(e, corner),
            style: {
              position: "absolute",
              width: HANDLE_SIZE,
              height: HANDLE_SIZE,
              background: color,
              borderRadius: 2,
              cursor: `${corner}-resize`,
              zIndex: 25,
              ...corner === "se" ? { right: -HANDLE_SIZE / 2, bottom: -HANDLE_SIZE / 2 } : {},
              ...corner === "sw" ? { left: -HANDLE_SIZE / 2, bottom: -HANDLE_SIZE / 2 } : {},
              ...corner === "ne" ? { right: -HANDLE_SIZE / 2, top: -HANDLE_SIZE / 2 } : {},
              ...corner === "nw" ? { left: -HANDLE_SIZE / 2, top: -HANDLE_SIZE / 2 } : {}
            }
          },
          corner
        ))
      ]
    }
  );
}

// src/components/verification/coordinateTransforms.ts
function pdfMapperToNormalized(coords, pageWidth, pageHeight) {
  if (!coords || pageWidth <= 0 || pageHeight <= 0) return null;
  const parts = coords.split(",").map(Number);
  if (parts.length !== 4 || parts.some(isNaN)) return null;
  const [x, y, w, h] = parts;
  return {
    x: x / pageWidth,
    y: y / pageHeight,
    w: w / pageWidth,
    h: h / pageHeight
  };
}
function normalizedToPdfMapper(box, pageWidth, pageHeight) {
  const x = Math.round(box.x * pageWidth);
  const y = Math.round(box.y * pageHeight);
  const w = Math.round(box.w * pageWidth);
  const h = Math.round(box.h * pageHeight);
  return `${x},${y},${w},${h}`;
}
function normalizedToPixels(box, pageWidth, pageHeight, scale = 1) {
  return {
    left: box.x * pageWidth * scale,
    top: box.y * pageHeight * scale,
    width: box.w * pageWidth * scale,
    height: box.h * pageHeight * scale
  };
}
function pixelsToNormalized(px, pageWidth, pageHeight, scale = 1) {
  const sw = pageWidth * scale;
  const sh = pageHeight * scale;
  return {
    x: px.left / sw,
    y: px.top / sh,
    w: px.width / sw,
    h: px.height / sh
  };
}
function pixelsToPdfMapper(px, pageWidth, pageHeight, scale = 1) {
  return normalizedToPdfMapper(
    pixelsToNormalized(px, pageWidth, pageHeight, scale),
    pageWidth,
    pageHeight
  );
}

export { EditableBox, MappingVerificationWizard, PdfViewer, normalizedToPdfMapper, normalizedToPixels, pdfMapperToNormalized, pixelsToNormalized, pixelsToPdfMapper };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map